<template>
  <form
    :class="'form_' + (thisform.name ? thisform.name.norm() : ' ')"
    style="height: -webkit-fill-available"
    v-if="show.form && thisform && models"
    @submit.prevent="
      submitMethod(thisform.submit.method, {
        data: models,
        type: thisform.submit.type,
      })
    "
  >
    <layout
      alignfoot="end"
      :relative="relative"
      :id="`iform_layout_${thisform.name}`"
    >
      <template #header class="form_header">
        <!-- <b class="l4 t4">{{thisform.name.toUpperCase()}}</b> -->
        <div
          v-if="thisform.description"
          class="flex wrap between align-center p8"
        >
          <code class="xs-font">{{ form.description }}</code>
        </div>
        <div
          v-if="wizardStage > 0 && thisform.forms.length > 1"
          style="width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
          class="form_header h-scroll"
        >
          <div class="flex stretch between align-center">
            <span class="flex align-center" v-if="searchenabled">
              <i
                @click="$set(show, 'searchform', !show.searchform)"
                :class="(thisform.submit.method || 'update') + '-text'"
                class="fa fa-search l8"
              />
              <input
                autofocus="true"
                v-if="show.searchform"
                type="search"
                :class="
                  (thisform.submit.method || 'update') +
                  '-border ' +
                  (thisform.submit.method || 'update') +
                  '-text'
                "
                class="r16 sm-input"
                v-model="formsearch"
                placeholder="Search inputs"
              />
            </span>
            <b class="l8 r8">{{ thisform.name }}</b>
            <span
              @click="
                wizardStage = num;
                scrollUp((thisform.name + wizardStage).norm());
              "
              :key="num"
              v-for="num in thisform.forms.length"
              class="xs-font flexy flex center t4"
              :class="
                num === wizardStage
                  ? (thisform.submit.method || 'update') + '-text p16'
                  : ''
              "
              type="button"
              :style="
                num === wizardStage
                  ? `font-weight: 900; border: solid 1px ${
                      $store.state.app.style[
                        thisform.submit.method == 'create'
                          ? 'success'
                          : thisform.submit.method || 'update'
                      ]
                    }; border-left-width: 1px; border-top-width: 1px; border-bottom-width: 0; border-right-width: 1px;`
                  : `border-bottom: 1px solid ${
                      $store.state.app.style[
                        thisform.submit.method == 'create'
                          ? 'success'
                          : thisform.submit.method || 'update'
                      ]
                    }; align-self: normal;`
              "
            >
              <span>{{ thisform.forms[num - 1].name.toUpperCase() }}</span>
            </span>
            <!-- <button
              :disabled="
                Object.keys(required).length > 0 &&
                JSON.stringify(required).indexOf('false') > -1
              "
              type="submit"
              class="m8 flex column p8 xs-font update"
            >
              {{
                submittext
                  ? submittext
                  : thisform.name === "Checkout"
                  ? "PURCHASE"
                  : prefill
                  ? "UPDATE"
                  : thisform.submit.method.toUpperCase()
              }}
            </button>-->
          </div>
          <div
            v-if="
              Object.keys(required).length > 0 &&
              JSON.stringify(required).indexOf('false') > -1
            "
            class="sm-font"
          >
            Please select or complete all required
            <code class="red">*</code> fields to proceed
          </div>
        </div>
      </template>
      <template #content>
        <div
          :id="(thisform.name + wizardStage).norm()"
          class="fill form_content"
          :key="formKey"
          v-for="(form, formKey) in thisform.forms"
          :style="
            models.style && form.name === 'style'
              ? 'background-size: cover; background: url(' +
                models.style.background +
                ') center center no-repeat; color: ' +
                models.style.color +
                '; background: ' +
                models.style.container
              : ''
          "
        >
          <div
            v-if="wizardStage > 0 ? formKey === wizardStage - 1 : true"
            class="flex column flexy b32"
          >
            <div class="xs-font p8 flexy" v-if="form.name === 'pages'">
              <div class="fill flex column">
                <label for="add-page">New Page</label>
                <div class="flex wrap">
                  <input
                    class="xs-input flexy xs-font"
                    id="add-page"
                    v-model="addPageTitle"
                    placeholder="Add another page"
                  />
                  <button
                    type="button"
                    class="fit p4 l8"
                    :class="addPageTitle.length > 0 ? 'update' : ''"
                    @click="
                      const pageData = {
                        text: '',
                        components: [],
                        pages: [],
                        styles: { style: {}, classes: '' },
                        published: true,
                      };
                      form.inputs.push({
                        inputType: 'page',
                        label: addPageTitle.norm(),
                        type: 'text',
                        placeholder: addPageTitle,
                        default: pageData,
                      });
                      $set(
                        models.pages,
                        addPageTitle.norm(),
                        pageData
                      );
                      // Also add to store so pageadmin component can access it
                      if (!$store.state.app.pages) {
                        $set($store.state.app, 'pages', {});
                      }
                      $set(
                        $store.state.app.pages,
                        addPageTitle.norm(),
                        pageData
                      );
                      addPageTitle = '';
                    "
                    :disabled="addPageTitle.length < 1"
                  >
                    <i class="fas fa-plus fa-sm"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- INPUTS -->
            <div class="flexy wrap flex b8 v-scroll">
              <div class="flex wrap" v-if="form.inputs">
                <div
                  :key="inputKey"
                  v-for="(input, inputKey) in form.inputs"
                  class="fill"
                >
                  <div
                    v-if="
                      ((!formsearch ||
                        JSON.stringify(input)
                          .toLowerCase()
                          .includes(formsearch.toLowerCase())) &&
                        !input.if) ||
                      (input.if &&
                        conditionscheck(input.if, models[form.name]))
                    "
                    class="wrap flex flexy align-center p8"
                    style="min-width: 270px"
                  >
                    <div class="flex fill flexy column">
                      <!-- LABEL -->

                      <label
                        :for="input.label || ''"
                        class="flex fit xs-font r4 border-bottom b4"
                      >
                        <b
                          class="align-center r8"
                          @click="
                            $set(
                              show.label,
                              [inputKey + (input.label || '')],
                              !show.label[inputKey + (input.label || '')]
                            )
                          "
                        >
                          <i
                            v-if="
                              form.inputs && form.inputs.length >= 6 &&
                              !'selectinputtextareacheckdate-time'.includes(
                                input.inputType || ''
                              )
                            "
                            class="r4"
                            :class="`fas fa-${
                              !show.label[inputKey + (input.label || '')]
                                ? 'plus'
                                : 'minus'
                            }-square`"
                          ></i>
                          {{ (input.label || '').toUpperCase() }}
                          <i
                            class="fa fa-copy"
                            v-if="input.copy || (input.label || '') === 'database'"
                            @click="$copyText(models[form.name][input.label || ''])"
                          ></i>
                        </b>
                        <ilink
                          v-if="form.name === 'pages'"
                          mode="hidden"
                          :to="`/page/${input.label || ''}`"
                          :label="input.label || ''"
                        />
                        <code v-if="input.required" class="red">*</code>
                      </label>
                      <div
                        class="fill"
                        v-if="
                          (form.inputs && form.inputs.length <= 6) ||
                          show.label[inputKey + (input.label || '')] ||
                          'selectinputtextareacheckdate-time'.includes(
                            input.inputType || ''
                          )
                        "
                      >
                        <button
                          :type="input.type || 'button'"
                          :class="input.class || 'update'"
                          v-if="input.inputType == 'button'"
                          @click="
                            $store[input.methodtype](
                              input.method,
                              input.payload
                            )
                          "
                        >
                          {{ input.text }}
                        </button>

                        <!-- NUMBER -->
                        <input
                          :disabled="input.disabled"
                          :autocomplete="input.autocomplete"
                          :id="input.label.norm()"
                          :class="input.label.norm()"
                          :minlength="input.min"
                          :maxlength="input.max"
                          :onchange="
                            input.required
                              ? models[form.name][input.label].toString()
                                  .length === input.max
                                ? (required[form.name][input.label] = true)
                                : (required[form.name][input.label] = false)
                              : null
                          "
                          :pattern="input.pattern"
                          :placeholder="input.placeholder"
                          :required="input.required"
                          :style="`min-width: 0; width: ${
                            input.max ? input.max * 10.7 + 'px' : 'auto'
                          }`"
                          class="md-font flexy"
                          v-model.number="models[form.name][input.label]"
                          v-if="
                            input.inputType == 'input' && input.type == 'number'
                          "
                          type="tel"
                        />

                        <!-- TEXT -->
                        <input
                          :disabled="input.disabled"
                          :autocomplete="input.autocomplete"
                          :autofocus="input.autofocus"
                          :onchange="
                            input.required
                              ? models[form.name][input.label].toString()
                                  .length > 0
                                ? (required[form.name][input.label] = true)
                                : (required[form.name][input.label] = false)
                              : null
                          "
                          :required="input.required"
                          :id="input.label.norm()"
                          :class="input.label.norm()"
                          :type="input.type"
                          :placeholder="input.placeholder"
                          class="sm-font"
                          v-model="models[form.name][input.label]"
                          v-if="
                            input.inputType == 'input' && (input.type == 'text' || input.type == 'password')
                          "
                        />

                        <!-- COLOR -->
                        <div
                          :style="`background: ${
                            models[form.name][input.label]
                          }`"
                          class="flex fit sub-container align-center"
                          v-if="
                            input.inputType == 'input' && input.type == 'color'
                          "
                        >
                          <label
                            v-if="!$store.state.device.mobile"
                            class="flex column xs-font"
                            :for="`color-${form.name + input.label}`"
                          >
                            <input
                              :disabled="input.disabled"
                              :id="`color-${
                                form.name.norm() + input.label.norm()
                              }`"
                              :class="`color-${
                                form.name.norm() + input.label.norm()
                              }`"
                              class="flexz xs-font"
                              v-model="models[form.name][input.label]"
                              :type="input.type"
                              :placeholder="input.placeholder"
                            />
                          </label>
                          <label
                            class="flex column xs-font"
                            :for="`color-${form.name + input.label}-rgba`"
                          >
                            <input
                              :disabled="input.disabled"
                              class="flexz xs-font"
                              v-model="models[form.name][input.label]"
                              :id="`color-${
                                form.name.norm() + input.label.norm()
                              }-rgba`"
                              :class="`color-${
                                form.name.norm() + input.label.norm()
                              }-rgba`"
                              type="text"
                              placeholder="Enter RGBA value 'rgba(150, 150, 150, .5)'"
                            />
                          </label>
                        </div>

                        <!-- TEXTAREA -->

                        <textarea
                          v-if="input.inputType == 'textarea'"
                          :disabled="input.disabled"
                          :autocomplete="
                            input.autocomplete === null
                              ? true
                              : input.autocomplete
                          "
                          :required="input.required"
                          class="flexy sm-font fill flex"
                          v-model="models[form.name][input.label]"
                          :id="input.label.norm()"
                          :class="input.label.norm()"
                          :type="input.type"
                          :placeholder="input.placeholder"
                        ></textarea>

                        <!-- TAGS -->
                        <div
                          class="flex wrap column"
                          v-if="input.inputType.toLowerCase() === 'tags'"
                        >
                          <div class="flex b8 align-start">
                            <input
                              class="xs-font xs-input"
                              id="tags"
                              v-model="newTag"
                              placeholder="Add keyword"
                            />
                            <button
                              type="button"
                              :disabled="newTag.length < 2"
                              class="r16 button xs-font"
                              @click="
                                models[form.name][input.label].forEach
                                  ? models[form.name][input.label].push(
                                      newTag.replace(/ /g, '-')
                                    )
                                  : (models[form.name][input.label] = [
                                      newTag.replace(/ /g, '-'),
                                    ]);
                                newTag = '';
                              "
                            >
                              <i class="fa-xs fa fa-hashtag"></i>
                            </button>
                          </div>
                          <span class="flex wrap">
                            <code
                              class="tag-button r4 b4 xs-font"
                              @click="
                                models[form.name][input.label].splice(
                                  tagIndex,
                                  1
                                )
                              "
                              :key="tagIndex"
                              v-for="(tag, tagIndex) in models[form.name][
                                input.label
                              ]"
                            >
                              <i class="fa fa-hashtag"></i>
                              {{ tag }}
                            </code>
                          </span>
                        </div>

                        <!-- Api   -->
                        <div
                          v-if="input.inputType == 'api'"
                          class="container p4"
                        >
                          <div class="flex between">
                            <b>API</b>
                            <div @click="$set(show, 'addapi', true)">
                              Add endpoint
                            </div>
                          </div>
                          <div class="flex align-center between">
                            <div
                              v-if="show.addapi"
                              class="flex align-center wrap"
                            >
                              <input
                                class="xs-font xs-input"
                                type="text"
                                v-model="
                                  newInput[
                                    form.name + '.' + input.label + '.apiname'
                                  ]
                                "
                                placeholder="Name"
                              />
                              <input
                                class="xs-font xs-input"
                                type="url"
                                v-model="
                                  newInput[
                                    form.name +
                                      '.' +
                                      input.label +
                                      '.apiendpoint'
                                  ]
                                "
                                placeholder="Endpoint"
                              />
                              <select
                                v-model="
                                  newInput[
                                    form.name + '.' + input.label + '.apiverb'
                                  ]
                                "
                                id
                              >
                                <option
                                  v-for="verb in [
                                    'get',
                                    'post',
                                    'delete',
                                    'option',
                                    'set',
                                    'patch',
                                  ]"
                                  :key="'newapi' + verb"
                                  :value="verb"
                                >
                                  {{ verb.toUpperCase() }}
                                </option>
                              </select>
                              <textarea
                                v-if="
                                  'postoptionsetpatch'.indexOf(
                                    newInput[
                                      form.name + '.' + input.label + '.apiverb'
                                    ]
                                  ) > -1
                                "
                                class="flexy fill xs-font xs-input"
                                type="url"
                                v-model="
                                  newInput[
                                    form.name + '.' + input.label + '.apimodel'
                                  ]
                                "
                                placeholder="Example data"
                              ></textarea>
                              <button
                                class="xs-font"
                                :disabled="
                                  !newInput[
                                    form.name +
                                      '.' +
                                      input.label +
                                      '.apiendpoint'
                                  ]
                                "
                                @click="
                                  !$store.state.app.api
                                    ? ($store.state.app.api = {})
                                    : null;
                                  $set(
                                    models[form.name][input.label],
                                    newInput[
                                      form.name + '.' + input.label + '.apiname'
                                    ],
                                    {
                                      address:
                                        newInput[
                                          form.name +
                                            '.' +
                                            input.label +
                                            '.apiendpoint'
                                        ],
                                      name: newInput[
                                        form.name +
                                          '.' +
                                          input.label +
                                          '.apiname'
                                      ],
                                      verb: newInput[
                                        form.name +
                                          '.' +
                                          input.label +
                                          '.apiverb'
                                      ],
                                      model:
                                        newInput[
                                          form.name +
                                            '.' +
                                            input.label +
                                            '.apimodel'
                                        ] || {},
                                    }
                                  );
                                  newInput[
                                    form.name +
                                      '.' +
                                      input.label +
                                      '.apiendpoint'
                                  ] = '';
                                  newInput[
                                    form.name + '.' + input.label + '.apiverb'
                                  ] = '';
                                "
                                type="button"
                              >
                                Add API
                              </button>
                            </div>
                          </div>
                          <div>
                            <div
                              class="flex wrap between container p4"
                              style="word-break: break-word"
                              v-for="(api, apikey) in models[form.name][
                                input.label
                              ]"
                              :key="apikey"
                            >
                              <div>
                                <b
                                  v-if="
                                    !show['apiendpointedit' + apikey + 'name']
                                  "
                                  @click="
                                    $set(
                                      show,
                                      'apiendpointedit' + apikey + 'name',
                                      !show['apiendpointedit' + apikey + 'name']
                                    )
                                  "
                                  >{{ api.name }}</b
                                >
                                <input
                                  autofocus
                                  class="xs-font xs-input"
                                  @blur="
                                    $set(
                                      show,
                                      'apiendpointedit' + apikey + 'name',
                                      !show['apiendpointedit' + apikey + 'name']
                                    )
                                  "
                                  v-if="
                                    show['apiendpointedit' + apikey + 'name']
                                  "
                                  type="text"
                                  v-model="api.name"
                                />
                              </div>
                              <div>
                                <b
                                  v-if="
                                    !show[
                                      'apiendpointedit' + apikey + 'endpoint'
                                    ]
                                  "
                                  @click="
                                    $set(
                                      show,
                                      'apiendpointedit' + apikey + 'endpoint',
                                      !show[
                                        'apiendpointedit' + apikey + 'endpoint'
                                      ]
                                    )
                                  "
                                  >{{ api.address || api.endpoint }}</b
                                >
                                <input
                                  autofocus
                                  class="xs-font xs-input"
                                  @blur="
                                    $set(
                                      show,
                                      'apiendpointedit' + apikey + 'endpoint',
                                      !show[
                                        'apiendpointedit' + apikey + 'endpoint'
                                      ]
                                    )
                                  "
                                  v-if="
                                    show[
                                      'apiendpointedit' + apikey + 'endpoint'
                                    ]
                                  "
                                  type="text"
                                  v-model="api.address"
                                />
                              </div>
                              <div>
                                <select v-model="api.verb" id>
                                  <option
                                    v-for="verb in [
                                      'get',
                                      'post',
                                      'delete',
                                      'option',
                                      'set',
                                      'patch',
                                    ]"
                                    :key="'newapi' + verb"
                                    :value="verb"
                                  >
                                    {{ verb.toUpperCase() }}
                                  </option>
                                </select>
                              </div>
                              <div>
                                <div>
                                  <b
                                    v-if="
                                      !show[
                                        'apiendpointedit' + apikey + 'model'
                                      ]
                                    "
                                    @click="
                                      $set(
                                        show,
                                        'apiendpointedit' + apikey + 'model',
                                        !show[
                                          'apiendpointedit' + apikey + 'model'
                                        ]
                                      )
                                    "
                                    >{{ api.model }}</b
                                  >
                                  <textarea
                                    placeholder="Set example data"
                                    autofocus
                                    class="xs-font xs-input"
                                    @blur="
                                      $set(
                                        show,
                                        'apiendpointedit' + apikey + 'model',
                                        !show[
                                          'apiendpointedit' + apikey + 'model'
                                        ]
                                      )
                                    "
                                    v-if="
                                      show[
                                        'apiendpointedit' + apikey + 'model'
                                      ] ||
                                      ('postoptionsetpatch'.indexOf(api.verb) >
                                        -1 &&
                                        !api.model)
                                    "
                                    type="text"
                                    v-model="api.model"
                                  ></textarea>
                                </div>
                              </div>
                              <i
                                @click="
                                  !api.hook ? $set(api, 'hook', {}) : null
                                "
                                class="fa fa-fish"
                              ></i>
                              <hooks
                                v-if="api.hook"
                                :name="'api_' + apikey"
                                :value="api.hook"
                                :item="api.hook"
                              />
                              <i
                                class="m4 fa fa-trash"
                                @click="
                                  models[form.name][input.label].splice(
                                    apikey,
                                    1
                                  )
                                "
                              ></i>
                            </div>
                          </div>
                        </div>

                        <!-- Functions -->
                        <function v-if="input.inputType == 'functions'" />

                        <!-- Smart Contracts -->
                        <smartcontracts v-if="input.inputType == 'smartcontracts'" />

                        <!-- Hooks -->
                        <div v-if="input.inputType == 'hooks'">
                          <div
                            :class="
                              show[
                                `app_${form.name}_${input.label}_${hooktype}`
                              ]
                                ? 'update-border t4 b4'
                                : ''
                            "
                            class="flex"
                            v-for="hooktype in [
                              'app',
                              'profile',
                              'dashboard',
                              'login',
                              'transaction',
                            ]"
                            :key="hooktype"
                          >
                            <b
                              class="xs-font p4"
                              :class="
                                models[form.name][input.label] &&
                                models[form.name][input.label][hooktype] &&
                                models[form.name][input.label][hooktype].fun
                                  ? 'update'
                                  : ''
                              "
                              @click="
                                !models[form.name][input.label][hooktype]
                                  ? $set(
                                      models[form.name][input.label],
                                      hooktype,
                                      {}
                                    )
                                  : null;
                                $set(
                                  show,
                                  `app_${form.name}_${input.label}_${hooktype}`,
                                  !show[
                                    `app_${form.name}_${input.label}_${hooktype}`
                                  ]
                                );
                              "
                            >
                              <i
                                :class="`r4 fa fa-${
                                  show[
                                    `app_${form.name}_${input.label}_${hooktype}`
                                  ]
                                    ? 'minus'
                                    : 'plus'
                                }`"
                              ></i>
                              {{ hooktype }}
                            </b>
                            <hooks
                              v-if="
                                models[form.name][input.label][hooktype] &&
                                show[
                                  `app_${form.name}_${input.label}_${hooktype}`
                                ]
                              "
                              :name="`app_${form.name}_${input.label}_${hooktype}`"
                              :item="models[form.name][input.label][hooktype]"
                              :value="models[form.name][input.label][hooktype]"
                            />
                          </div>
                        </div>
                        <!-- Meta -->
                        <div
                          v-if="input.inputType == 'meta'"
                          class="container p4"
                        >
                          <div class="flex wrap">
                            <button
                              v-if="!newInput['addmeta']"
                              type="button"
                              class="p4 xs-font success"
                              @click="$set(newInput, 'addmeta', {})"
                            >
                              <i class="fa fa-plus"></i>
                            </button>
                            <div
                              class="container p4 xs-font"
                              v-if="newInput['addmeta']"
                            >
                              <select v-model="newInput['addmeta'].element">
                                <option
                                  :value="element"
                                  :key="element"
                                  v-for="element in ['link', 'script', 'meta']"
                                >
                                  {{ element }}
                                </option>
                              </select>
                              <b
                                v-if="newInput['addmeta'].element"
                                class="xs-font update-text m4"
                                @click="$set(newInput, 'addattribute', {})"
                                >Add Attribute</b
                              >
                              <div
                                v-if="newInput['addattribute']"
                                class="flex column p4"
                              >
                                <input
                                  class="xs-input"
                                  type="text"
                                  v-model="newInput['addattribute'].key"
                                  placeholder="Attribute Type"
                                />
                                <input
                                  class="xs-input"
                                  type="text"
                                  v-model="newInput['addattribute'].value"
                                  placeholder="Attribute Value"
                                />
                                <button
                                  :disabled="!newInput['addattribute'].key"
                                  @click="
                                    $set(
                                      newInput['addmeta'],
                                      newInput['addattribute'].key,
                                      newInput['addattribute'].value
                                    );
                                    $set(newInput, 'addattribute', null);
                                  "
                                  type="button"
                                  class="xs-font update p4 t4"
                                >
                                  Add Attribute
                                </button>
                              </div>
                              <div
                                class="xs-font"
                                v-for="(val, prop) in newInput['addmeta']"
                                :key="prop"
                              >
                                <b>{{ prop }}</b>
                                : {{ val }}
                                <rm
                                  class="m4"
                                  :name="prop"
                                  :obj="newInput['addmeta']"
                                />
                              </div>

                              <button
                                :disabled="
                                  !newInput['addmeta'].element &&
                                  Object.keys(newInput['addmeta']).length <= 1
                                "
                                @click="
                                  models[form.name][input.label].push(
                                    newInput['addmeta']
                                  );
                                  newInput['addmeta'] = null;
                                "
                                type="button"
                                class="xs-font success t4 p8"
                              >
                                Add Script
                              </button>
                            </div>
                          </div>
                          <div
                            class="flex align-center wrap xs-font"
                            v-for="(meta, metai) in models[form.name][
                              input.label
                            ]"
                            :key="metai"
                          >
                            <i class="fa fa-less-than" />
                            <b>
                              {{ meta.element }}
                            </b>
                            <div
                              class="l4"
                              v-for="(attr, attrkey) in meta"
                              :key="attrkey"
                            >
                              <span v-if="attrkey !== 'element'">
                                <span v-text="attrkey"></span>="
                                <span
                                  @blur="
                                    edited
                                      ? $set(
                                          input.default[metai],
                                          attrkey,
                                          edited
                                        )
                                      : null;
                                    edited = '';
                                  "
                                  @input="onEdit"
                                  contenteditable
                                  >{{ attr }}</span
                                >"
                              </span>
                            </div>
                            /
                            <i class="fa fa-greater-than r4" />
                            <add
                              type="object"
                              :obj="meta"
                              :fn="{
                                command: 'dispatch',
                                method: 'update',
                                type: 'app',
                                obj: '$store.state.app',
                              }"
                            />
                            <rm
                              class="m4"
                              :name="metai"
                              :obj="$store.state.app.basics.meta"
                              :fn="{
                                command: 'dispatch',
                                method: 'update',
                                type: 'app',
                                obj: '$store.state.app',
                              }"
                            />
                          </div>
                        </div>

                        <!-- MENUS -->
                        <!-- <iform
                          :form-model="$store.state.models.menus"
                          :prefill="input.default"
                          v-if="input.inputType == 'form'"
                        />-->
                        <div
                          class="p4 container b4 xs-font"
                          v-if="input.inputType == 'menus'"
                        >
                          <div class="flex between align-center">
                            <div class="flex align-center">
                              <label for="menus">
                                <input
                                  class="r4 flexy xs-input xs-font"
                                  id="menus"
                                  v-model="newMenu"
                                  placeholder="Add menu"
                                />
                              </label>
                              <button
                                type="button"
                                :disabled="newMenu.length <= 2"
                                class="success p4 xs-font"
                                @click="
                                  models[form.name][input.label][newMenu] = {
                                    class: '',
                                    style: {},
                                    links: [
                                      { name: '', type: '', conditions: {} },
                                    ],
                                  };
                                  newMenu = '';
                                "
                              >
                                <i class="fas fa-plus"></i>
                                <span class="l4" v-if="newMenu.length > 2"
                                  >Create menu</span
                                >
                              </button>
                            </div>
                          </div>
                          <div
                            class
                            v-for="(menu, menukey) in models[form.name][
                              input.label
                            ]"
                            :key="menukey"
                          >
                            <span
                              v-if="menu"
                              class="
                                flex
                                between
                                align-center
                                container
                                update-border
                                t4
                                b4
                              "
                            >
                              <h4 class="flexy">
                                <b
                                  class="update p4"
                                  @click="
                                    $set(
                                      show,
                                      'menus' + menukey,
                                      !show['menus' + menukey]
                                    )
                                  "
                                >
                                  <i
                                    :class="`fa fa-${
                                      show['menus' + menukey]
                                        ? 'minus-'
                                        : 'plus-'
                                    }square`"
                                  />
                                  {{ menukey }}
                                </b>
                              </h4>
                              <div class="flex between align-center flexy">
                                <a
                                  @click="
                                    $set(show, 'menus' + menukey, true);
                                    models[form.name][input.label][
                                      menukey
                                    ].links.push({
                                      name: '',
                                      type: '',
                                      conditions: {},
                                    });
                                  "
                                >
                                  <i class="fa fa-plus" />
                                </a>
                                <i
                                  class="fa fa-eye"
                                  @click="
                                    $set(
                                      show,
                                      'menus' + menukey + 'show',
                                      !show['menus' + menukey + 'show']
                                    )
                                  "
                                ></i>
                                <i
                                  class="fa fa-compress"
                                  :class="menu && menu['nohide'] && 'warn-text'"
                                  @click="$set(menu, 'nohide', !menu['nohide'])"
                                ></i>
                                <div>
                                  <i
                                    @click="
                                      !menu.hook
                                        ? $set(menu, 'hook', {})
                                        : null;
                                      $set(
                                        show,
                                        'menus_hook_' + menukey,
                                        !show['menus_hook_' + menukey]
                                      );
                                    "
                                    class="fa fa-fish"
                                  ></i>
                                  <hooks
                                    v-if="
                                      menu.hook && show['menus_hook_' + menukey]
                                    "
                                    :name="'menus_' + menukey"
                                    :value="menu.hook"
                                    :item="menu.hook"
                                  />
                                </div>
                                <a
                                  v-if="!show['menus' + menukey + 'class']"
                                  @click="
                                    $set(
                                      show,
                                      'menus' + menukey + 'class',
                                      true
                                    );
                                    models[form.name][input.label][
                                      menukey
                                    ].links.push({
                                      name: '',
                                      type: '',
                                      conditions: {},
                                    });
                                  "
                                >
                                  <i class="fa fa-edit" />
                                </a>

                                <input
                                  v-if="show['menus' + menukey + 'class']"
                                  placeholder="classes"
                                  class="xs-font xs-input"
                                  type="text"
                                  v-model="menu.class"
                                />
                                <i
                                  class="m4 fa fa-trash"
                                  @click="$set(input.default, menukey, null)"
                                ></i>
                              </div>
                            </span>
                            <inav
                              :name="menukey"
                              v-if="show['menus' + menukey + 'show']"
                            />
                            <div
                              v-if="menu && show['menus' + menukey]"
                              class="m4"
                            >
                              <div
                                v-for="(link, linkkey) in menu.links"
                                :key="linkkey"
                                class="flex wrap p4 border-bottom"
                              >
                                <div>
                                  <div class="flex wrap between">
                                    <span>
                                      <i
                                        @click="
                                          values[0] = link;
                                          menu.links[linkkey] =
                                            menu.links[linkkey - 1];
                                          show['menus' + menukey + linkkey]
                                            ? ((show[
                                                'menus' + menukey + linkkey
                                              ] = false),
                                              (show[
                                                'menus' +
                                                  menukey +
                                                  (linkkey - 1)
                                              ] = true))
                                            : null;
                                          $set(
                                            menu.links,
                                            linkkey - 1,
                                            values[0]
                                          );
                                          values = [];
                                        "
                                        v-if="linkkey !== 0"
                                        class="fa fa-arrow-up"
                                      ></i>
                                      <i
                                        @click="
                                          values[0] = link;
                                          menu.links[linkkey] =
                                            menu.links[linkkey + 1];
                                          show['menus' + menukey + linkkey]
                                            ? ((show[
                                                'menus' + menukey + linkkey
                                              ] = false),
                                              (show[
                                                'menus' +
                                                  menukey +
                                                  (linkkey + 1)
                                              ] = true))
                                            : null;
                                          $set(
                                            menu.links,
                                            linkkey + 1,
                                            values[0]
                                          );
                                        "
                                        v-if="linkkey !== menu.links.length - 1"
                                        class="fa fa-arrow-down l4 r8"
                                      ></i>
                                      <span
                                        @click="
                                          $set(
                                            show,
                                            'menus' + menukey + linkkey,
                                            !show['menus' + menukey + linkkey]
                                          )
                                        "
                                      >
                                        <b>
                                          {{ link.name || "Link" + linkkey }}
                                        </b>
                                      </span>
                                      <input
                                        v-if="show['menus' + menukey + linkkey]"
                                        placeholder="Link name"
                                        class="xs-font xs-input"
                                        type="text"
                                        v-model="link.name"
                                      />
                                      <div
                                        class="align-center flex"
                                        v-if="
                                          !models[form.name][input.label][
                                            menukey
                                          ].links[linkkey].type ||
                                          models[form.name][input.label][
                                            menukey
                                          ].links[linkkey].type === 'link'
                                        "
                                      >
                                        To
                                        <input
                                          class="l4 xs-font xs-input"
                                          type="text"
                                          v-model="link.to"
                                        />
                                      </div>
                                    </span>
                                  </div>

                                  <div
                                    v-if="show['menus' + menukey + linkkey]"
                                    class="flex wrap align-center"
                                  >
                                    <div class="flex wrap">
                                      <i
                                        v-if="
                                          link.display &&
                                          link.display.indexOf('icon') > -1
                                        "
                                        :class="link.icon + ' fa-3x m4'"
                                      />
                                      <img
                                        class="m4"
                                        v-if="
                                          link.display &&
                                          link.display.indexOf('image') > -1
                                        "
                                        :src="link.image"
                                        style="
                                          height: 24px;
                                          width: 28px;
                                          object-fit: cover;
                                        "
                                      />
                                      <i
                                        class="m4 fa fa-trash"
                                        @click="
                                          models[form.name][input.label][
                                            menukey
                                          ].links.splice(linkkey, 1)
                                        "
                                      ></i>
                                    </div>
                                    <div>
                                      <div>Type</div>
                                      <select
                                        @change="
                                          link.type == 'component' &&
                                          !link.component
                                            ? (link.component = {
                                                name: '',
                                                props: {},
                                              })
                                            : null
                                        "
                                        :selected="link.type"
                                        v-model="link.type"
                                      >
                                        <option
                                          v-for="t in [
                                            'link',
                                            'action',
                                            'mutation',
                                            'subnav',
                                            'component',
                                          ]"
                                          :key="t"
                                          :value="t"
                                        >
                                          {{ t }}
                                        </option>
                                      </select>
                                    </div>
                                    <div>
                                      <div>Display</div>
                                      <select v-model="link.display">
                                        <option
                                          :value="opt"
                                          v-for="opt in [
                                            'text',
                                            'icon+text',
                                            'image+text',
                                            'icon',
                                            'image',
                                          ]"
                                          :key="opt"
                                        >
                                          {{ opt }}
                                        </option>
                                      </select>
                                      <div
                                        v-if="
                                          link.display &&
                                          (link.display.indexOf('icon') > -1 ||
                                            link.display.indexOf('image') > -1)
                                        "
                                      >
                                        <span
                                          @click="
                                            $set(
                                              show,
                                              'symbol' + menukey + linkkey,
                                              !show[
                                                'symbol' + menukey + linkkey
                                              ]
                                            )
                                          "
                                        >
                                          <i
                                            :class="`fa fa-${
                                              !show[
                                                'symbol' + menukey + linkkey
                                              ]
                                                ? 'plus-square'
                                                : 'minus-square'
                                            }`"
                                          ></i>
                                          Select Symbol
                                        </span>
                                        <div
                                          v-if="
                                            show[
                                              'symbol' + menukey + linkkey
                                            ] &&
                                            link.display.indexOf('image') > -1
                                          "
                                        >
                                          <div
                                            style="position: relative"
                                            class="
                                              flex
                                              wrap
                                              container
                                              around
                                              align-center
                                            "
                                          >
                                            <div
                                              class="xs-font flex column fill"
                                              :style="`background: url(${link.image}) no-repeat center center; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover; height: 240px`"
                                            >
                                              <div
                                                class="
                                                  flex
                                                  column
                                                  b8
                                                  center
                                                  fill
                                                  flexw
                                                "
                                              >
                                                <label
                                                  style="position: absolute"
                                                  :style="`border: 1px dashed ${$store.state.app.style.color}; `"
                                                  class="xs-font label p4"
                                                  :for="`file-${
                                                    form.name +
                                                    input.label +
                                                    link.name
                                                  }`"
                                                >
                                                  <b>
                                                    <i
                                                      class="
                                                        fas
                                                        fa-angle-right fa-sm
                                                      "
                                                    ></i>
                                                    Tap or Drag
                                                    <i
                                                      class="
                                                        fas
                                                        fa-angle-left fa-sm
                                                      "
                                                    ></i>
                                                  </b>
                                                </label>

                                                <div
                                                  class="fill"
                                                  :style="`border: 2px dashed ${$store.state.app.style.color}; box-shadow: inset 0 0 2px ${$store.state.app.style.container}; height: 100%`"
                                                >
                                                  <input
                                                    multiple="true"
                                                    :id="`file-${
                                                      form.name.norm() +
                                                      input.label.norm() +
                                                      link.name.norm()
                                                    }`"
                                                    :class="`file-${
                                                      form.name.norm() +
                                                      input.label.norm() +
                                                      link.name.norm()
                                                    }`"
                                                    type="file"
                                                    :style="`border: 1px dashed ${$store.state.app.style.container}; box-shadow: inset 0 0 1px  ${$store.state.app.style.color}; height: 100%`"
                                                    name="upload"
                                                    @change="
                                                      $store
                                                        .dispatch('util', {
                                                          type: 'hash',
                                                          body: $event.target
                                                            .files,
                                                        })
                                                        .then((x) =>
                                                          console.log(x)
                                                        );
                                                      prepUpload(
                                                        $event.target.files,
                                                        form.name,
                                                        input.label,
                                                        [
                                                          menukey,
                                                          'links',
                                                          linkkey,
                                                        ]
                                                      );
                                                    "
                                                    :accept="
                                                      input.type === 'image'
                                                        ? 'image/*'
                                                        : '*'
                                                    "
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  flex
                                                  column
                                                  xs-font
                                                  p8
                                                  fill
                                                "
                                              >
                                                <label
                                                  class="xs-font label"
                                                  :for="
                                                    form.name +
                                                    input.label +
                                                    link.name
                                                  "
                                                  >Image URL</label
                                                >
                                                <input
                                                  class="xs-font"
                                                  type="url"
                                                  :id="
                                                    form.name.norm() +
                                                    input.label.norm() +
                                                    link.name.norm()
                                                  "
                                                  :class="
                                                    form.name.norm() +
                                                    input.label.norm() +
                                                    link.name.norm()
                                                  "
                                                  v-model="link.image"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div>Icon</div>
                                        </div>
                                        <div
                                          v-if="
                                            show[
                                              'symbol' + menukey + linkkey
                                            ] &&
                                            link.display.indexOf('icon') > -1
                                          "
                                          class="flex wrap"
                                        >
                                          <input
                                            class="xs-font xs-input"
                                            type="text"
                                            v-model="searchIcon"
                                            placeholder="Search icons"
                                          />

                                          <input
                                            class="xs-font xs-input"
                                            type="text"
                                            v-model="link.icon"
                                            placeholder="Font Awesome 5 Classes"
                                          />

                                          <div class="flex wrap v-scroll">
                                            <span
                                              :key="iconKey"
                                              v-for="(icon, iconKey) in $store
                                                .state.icons.fulllist"
                                            >
                                              <span
                                                @click="
                                                  $set(link, 'icon', icon)
                                                "
                                                class="m4"
                                                :class="icon"
                                                v-if="
                                                  searchIcon.length === 0 ||
                                                  (searchIcon.length > 0 &&
                                                    icon.indexOf(searchIcon) >
                                                      -1)
                                                "
                                              ></span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>Condition</div>
                                      <div>
                                        <input
                                          placeholder="link class"
                                          type="text"
                                          class="xs-font xs-input"
                                          v-model="link.class"
                                        />
                                      </div>
                                      <div>Styles</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex wrap">
                                  <div
                                    v-if="
                                      models[form.name][input.label][menukey]
                                        .links[linkkey].type === 'component'
                                    "
                                  >
                                    <div>Component</div>
                                    <input
                                      class="xs-font xs-input"
                                      type="text"
                                      v-model="link.component.name"
                                    />
                                    <div class="container p8">
                                      <div class="flex between xs-font">
                                        <b>{{ link.component.name }}</b>
                                      </div>
                                      <div
                                        class="p4"
                                        v-for="(prop, propkey) in $cp[
                                          link.component.name
                                        ]"
                                        :key="propkey"
                                      >
                                        <div
                                          class="flex align-center xs-font wrap"
                                        >
                                          <b>{{ propkey }}</b>
                                          <span class="p8">
                                            <div
                                              v-if="
                                                prop.type === String ||
                                                (prop.type.includes &&
                                                  prop.type.includes(String))
                                              "
                                            >
                                              <input
                                                class="xs-input"
                                                :placeholder="
                                                  propkey + ' (string)'
                                                "
                                                type="text"
                                                v-model="
                                                  link.component.props[propkey]
                                                "
                                              />
                                            </div>
                                            <div
                                              v-if="
                                                prop.type === Boolean ||
                                                (prop.type.includes &&
                                                  prop.type.includes(Boolean))
                                              "
                                            >
                                              <input
                                                class="xs-input"
                                                :placeholder="propkey"
                                                type="checkbox"
                                                v-model="
                                                  link.component.props[propkey]
                                                "
                                              />
                                              <span
                                                @click="
                                                  $set(
                                                    link.component.props,
                                                    propkey,
                                                    !link.component.props[
                                                      propkey
                                                    ]
                                                  )
                                                "
                                              >
                                                <i
                                                  :class="
                                                    link.component.props[
                                                      propkey
                                                    ]
                                                      ? 'update-text'
                                                      : ''
                                                  "
                                                  >True</i
                                                >
                                                /
                                                <i
                                                  :class="
                                                    !link.component.props[
                                                      propkey
                                                    ]
                                                      ? 'update-text'
                                                      : ''
                                                  "
                                                  >False</i
                                                >
                                              </span>
                                            </div>
                                            <div
                                              v-if="
                                                prop.type === Number ||
                                                (prop.type.includes &&
                                                  prop.type.includes(Number))
                                              "
                                            >
                                              <input
                                                class="xs-input"
                                                :placeholder="
                                                  propkey + ' (number)'
                                                "
                                                type="number"
                                                v-model.number="
                                                  link.component.props[propkey]
                                                "
                                              />
                                              number
                                            </div>
                                            <div
                                              v-if="
                                                prop.type === Object ||
                                                prop.type === Array ||
                                                (prop.type.includes &&
                                                  prop.type.includes(Object))
                                              "
                                            >
                                              <code>
                                                {{
                                                  link.component.props[propkey]
                                                }}
                                              </code>

                                              <textarea
                                                :placeholder="`${
                                                  link.component.name.toUpperCase() +
                                                  ' ' +
                                                  propkey.toUpperCase()
                                                }\n{ Valid JSON }`"
                                                @change="
                                                  typeof JSON.parse(
                                                    newInput[
                                                      form.name +
                                                        '.' +
                                                        input.label +
                                                        '.components[' +
                                                        menukey +
                                                        '].props.' +
                                                        propkey
                                                    ]
                                                  ) === 'object'
                                                    ? (link.component.props[
                                                        propkey
                                                      ] = JSON.parse(
                                                        newInput[
                                                          form.name +
                                                            '.' +
                                                            input.label +
                                                            '.components[' +
                                                            menukey +
                                                            '].props.' +
                                                            propkey
                                                        ]
                                                      ))
                                                    : null
                                                "
                                                v-model="
                                                  newInput[
                                                    form.name +
                                                      '.' +
                                                      input.label +
                                                      '.components[' +
                                                      menukey +
                                                      '].props.' +
                                                      propkey
                                                  ]
                                                "
                                              ></textarea>
                                            </div>
                                          </span>
                                          <span
                                            class="
                                              flex
                                              align-center
                                              xs-font
                                              wrap
                                            "
                                          >
                                            <span
                                              v-if="
                                                $store.state.select[
                                                  form.name +
                                                    '.' +
                                                    input.label +
                                                    '.components[' +
                                                    menukey +
                                                    '].props.' +
                                                    propkey
                                                ]
                                              "
                                              class="xs-font m4"
                                            >
                                              <button
                                                class="update m4"
                                                type="button"
                                                @click="
                                                  $set(
                                                    link.component.props,
                                                    propkey,
                                                    $store.state.select[
                                                      form.name +
                                                        '.' +
                                                        input.label +
                                                        '.components[' +
                                                        menukey +
                                                        '].props.' +
                                                        propkey
                                                    ].val
                                                  )
                                                "
                                              >
                                                Assign Value
                                              </button>

                                              <button
                                                class="indicate m4"
                                                type="button"
                                                @click="
                                                  $set(
                                                    link.component.props,
                                                    propkey,
                                                    'p__' +
                                                      $store.state.select[
                                                        form.name +
                                                          '.' +
                                                          input.label +
                                                          '.components[' +
                                                          menukey +
                                                          '].props.' +
                                                          propkey
                                                      ].parent
                                                  )
                                                "
                                              >
                                                Assign Pointer
                                              </button>
                                              <a
                                                class="warn-text"
                                                @click="
                                                  $set(
                                                    $store.state.select,
                                                    form.name +
                                                      '.' +
                                                      input.label +
                                                      '.components[' +
                                                      menukey +
                                                      '].props.' +
                                                      propkey,
                                                    null
                                                  )
                                                "
                                                >Clear</a
                                              >
                                            </span>
                                            <div
                                              class="
                                                xs-font
                                                container
                                                flex
                                                p4
                                                wrap
                                                align-center
                                              "
                                            >
                                              <i class="fa fa-folder"></i> Find
                                              Values
                                              <input
                                                placeholder="Search State"
                                                class="xs-input xs-font"
                                                type="text"
                                                v-model="
                                                  search[
                                                    form.name +
                                                      '.' +
                                                      input.label +
                                                      '.components[' +
                                                      menukey +
                                                      '].props.' +
                                                      propkey
                                                  ]
                                                "
                                              />
                                              <state
                                                style="
                                                  display: flex;
                                                  flex-wrap: wrap;
                                                "
                                                :key="
                                                  form.name +
                                                  '.' +
                                                  input.label +
                                                  '.components[' +
                                                  menukey +
                                                  '].props.' +
                                                  propkey +
                                                  $store.state.counter
                                                "
                                                :searchdata="
                                                  search[
                                                    form.name +
                                                      '.' +
                                                      input.label +
                                                      '.components[' +
                                                      menukey +
                                                      '].props.' +
                                                      propkey
                                                  ]
                                                "
                                                :parent="
                                                  form.name +
                                                  '.' +
                                                  input.label +
                                                  '.components[' +
                                                  menukey +
                                                  '].props.' +
                                                  propkey +
                                                  '.state'
                                                "
                                                :statedata="$store.state"
                                                :select="
                                                  form.name +
                                                  '.' +
                                                  input.label +
                                                  '.components[' +
                                                  menukey +
                                                  '].props.' +
                                                  propkey
                                                "
                                              />
                                            </div>
                                            <span
                                              v-if="
                                                $store.state.select[
                                                  form.name +
                                                    '.' +
                                                    input.label +
                                                    '.components[' +
                                                    menukey +
                                                    '].props.' +
                                                    propkey
                                                ]
                                              "
                                            >
                                              {{
                                                $store.state.select[
                                                  form.name +
                                                    "." +
                                                    input.label +
                                                    ".components[" +
                                                    menukey +
                                                    "].props." +
                                                    propkey
                                                ].val
                                              }}
                                            </span>
                                          </span>
                                        </div>
                                        <!-- <input v-model="link['components'][option][propkey]"/>  -->
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      models[form.name][input.label][menukey]
                                        .links[linkkey].type === 'subnav'
                                    "
                                  >
                                    <div>Select Menu</div>
                                    <select v-model="link.menu">
                                      <option
                                        v-for="menu in Object.keys(
                                          $store.state.app.basics.menus
                                        )"
                                        :key="menu"
                                        :value="menu"
                                      >
                                        {{ menu }}
                                      </option>
                                    </select>
                                  </div>
                                  <div
                                    v-if="
                                      models[form.name][input.label][menukey]
                                        .links[linkkey].type === 'action'
                                    "
                                    class="flex column"
                                  >
                                    <div>Select Action</div>
                                    <select v-model="link.do">
                                      <option
                                        v-for="action in Object.keys(
                                          $store.state.vuex.actions
                                        )"
                                        :key="action"
                                        :value="action"
                                      >
                                        {{ action }}
                                      </option>
                                    </select>
                                    <textarea
                                      class="xs-input xs-font"
                                      placeholder="Payload (JSON)"
                                      v-model="link.payload"
                                    ></textarea>
                                  </div>
                                  <div
                                    v-if="
                                      models[form.name][input.label][menukey]
                                        .links[linkkey].type === 'mutation'
                                    "
                                    class="flex column"
                                  >
                                    <div>Select Mutation</div>
                                    <select v-model="link.do">
                                      <option
                                        v-for="mutation in Object.keys(
                                          $store.state.vuex.mutations
                                        )"
                                        :key="mutation"
                                        :value="mutation"
                                      >
                                        {{ mutation }}
                                      </option>
                                    </select>
                                    <textarea
                                      class="xs-input xs-font"
                                      placeholder="Payload (JSON)"
                                      v-model="link.payload"
                                    ></textarea>
                                  </div>
                                </div>

                                <!-- <div>
                                  <span @click="$set(show, 'condition'+menukey+link.name, !show['condition'+menukey+link.name])">Add conditions</span>
                                  <input
                                    v-if="show['condition'+menukey+link.name]"
                                    class="xs-input xs-font"
                                    type="text"
                                    v-model="newCondition[menukey+link.name]"
                                  />
                                  <button
                                  type="button"
                                    v-if="newCondition[menukey+link.name]"
                                    class="fa fa-plus"
                                    @click="!link.conditions ? link.conditions = {} : null; link.conditions[newCondition[menukey+link.name]] = ''; newCondition[menukey+link.name] = ''"
                                  ></button>
                                  <div
                                    class="flex align-center"
                                    v-for="(condition, conditionkey) in link.conditions"
                                    :key="conditionkey"
                                  >
                                    {{conditionkey}}
                                    <input
                                      v-model="link.conditions[conditionkey]"
                                      class="xs-font xs-input"
                                      type="text"
                                      placeholder="condition"
                                    />
                                    <i
                                      @click="$set(link.conditions, conditionkey, null)"
                                      class="fa fa-trash"
                                    ></i>
                                  </div>
                                </div>-->
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Roles -->
                        <div
                          v-if="input.inputType == 'roles'"
                          class="p4 container"
                        >
                          <div class="flex align-center wrap between b8">
                            <b>Roles</b>
                            <div>
                              <select v-model="show.roles">
                                <option
                                  v-for="(role, rolekey) in models[form.name][
                                    input.label
                                  ]"
                                  :value="rolekey"
                                  :key="rolekey"
                                >
                                  {{ rolekey }}
                                </option>
                              </select>
                              <i
                                v-if="show.roles"
                                @click="
                                  $delete(
                                    models[form.name][input.label],
                                    show.roles
                                  );
                                  show.roles = '';
                                "
                                class="fa fa-trash xs-font m4"
                              ></i>
                            </div>
                            <span class="flex align-center">
                              <input
                                placeholder="Add Role"
                                class="xs-input r4"
                                type="text"
                                v-model="newInput['newrole']"
                              />
                              <button
                                class="xs-font success p4"
                                @click="
                                  models[form.name][input.label][
                                    newInput['newrole']
                                  ] = {
                                    hooks: {},
                                    permissions: {},
                                    requirements: {},
                                    members: [],
                                  };
                                  show.roles = newInput['newrole'];
                                  newInput['newrole'] = '';
                                "
                              >
                                <i class="fas fa-plus" />
                              </button>
                            </span>
                          </div>
                          <div class="flex between wrap align-center b8">
                            <div
                              v-if="show.roles"
                              class="flex wrap around flexy"
                            >
                              <div class="sub-container xs-font">
                                <b>Sign-up Requirements</b>
                                <div
                                  class="container p4"
                                  v-for="(
                                    requirement, requirementkey
                                  ) in models[form.name][input.label][
                                    show.roles
                                  ].requirements"
                                  :key="requirementkey"
                                >
                                  <div class="flex align-center between">
                                    <div class="flex align-center">
                                      <b>{{ requirementkey }}</b>
                                      <button
                                        type="button"
                                        class="update xs-font p4 m4"
                                        @click="
                                          requirement.validations.push({
                                            type: '',
                                            value: '',
                                          })
                                        "
                                      >
                                        <i class="fa fa-plus" />
                                      </button>
                                    </div>
                                    <i
                                      class="fa fa-trash warn-text"
                                      @click="
                                        $delete(
                                          models[form.name][input.label][
                                            show.roles
                                          ].requirements,
                                          requirementkey
                                        )
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      flex
                                      align-center
                                      wrap
                                      m4
                                      p4
                                      container
                                      between
                                    "
                                    v-for="(
                                      validation, validationi
                                    ) in requirement.validations"
                                    :key="validationi"
                                  >
                                    <input
                                      type="text"
                                      v-model="
                                        requirement.validations[validationi]
                                          .value
                                      "
                                      placeholder="Validation value"
                                    />
                                    <select
                                      @change="
                                        requirement.validations[validationi]
                                          .type == 'select'
                                          ? (requirement.validations[
                                              validationi
                                            ].options = [])
                                          : null
                                      "
                                      v-model="
                                        requirement.validations[validationi]
                                          .type
                                      "
                                    >
                                      <option
                                        v-for="type in [
                                          'select',
                                          'text',
                                          'boolean',
                                          'number',
                                          'date',
                                        ]"
                                        :value="type"
                                        :key="type"
                                      >
                                        {{ type }}
                                      </option>
                                    </select>

                                    <i
                                      class="fa fa-trash warn-text"
                                      @click="
                                        requirement.validations.splice(
                                          validationi,
                                          1
                                        )
                                      "
                                    />
                                    <div
                                      v-if="
                                        requirement.validations[validationi]
                                          .type === 'select'
                                      "
                                    >
                                      <span
                                        class="flex align-center container p4"
                                      >
                                        <input
                                          type="text"
                                          v-model="
                                            newInput[
                                              'requirementoption' +
                                                requirementkey +
                                                validationi
                                            ]
                                          "
                                          placeholder="New select option"
                                        />
                                        <i
                                          v-if="
                                            newInput[
                                              'requirementoption' +
                                                requirementkey +
                                                validationi
                                            ] &&
                                            newInput[
                                              'requirementoption' +
                                                requirementkey +
                                                validationi
                                            ].length > 0
                                          "
                                          class="fa fa-plus"
                                          @click="
                                            requirement.validations[
                                              validationi
                                            ].options.push(
                                              newInput[
                                                'requirementoption' +
                                                  requirementkey +
                                                  validationi
                                              ]
                                            );
                                            newInput[
                                              'requirementoption' +
                                                requirementkey +
                                                validationi
                                            ] = '';
                                          "
                                        ></i>
                                        <div class="flex wrap">
                                          <b
                                            class="m4 flex align-center"
                                            type="text"
                                            v-for="(
                                              option, optioni
                                            ) in requirement.validations[
                                              validationi
                                            ].options"
                                            :key="optioni"
                                          >
                                            {{ option }}
                                            <i
                                              class="fa fa-trash m4"
                                              @click="
                                                requirement.validations[
                                                  validationi
                                                ].options.splice(optioni, 1)
                                              "
                                            ></i>
                                          </b>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <input
                                  v-model="newInput['roles.requirements']"
                                  class="xs-font xs-input"
                                  type="text"
                                  placeholder="Add required field"
                                />
                                <button
                                  @click="
                                    models[form.name][input.label][
                                      show.roles
                                    ].requirements[
                                      newInput['roles.requirements']
                                    ] = { validations: [], type: '' };
                                    newInput['roles.requirements'] = '';
                                  "
                                  type="button"
                                  class="update xs-font p4 fa fa-plus"
                                ></button>
                              </div>
                              <div class="sub-container xs-font">
                                <b>Hooks</b>
                                <hooks
                                  @change="
                                    !models[form.name][input.label][show.roles]
                                      .hooks &&
                                      $set(
                                        models[form.name][input.label][
                                          show.roles
                                        ],
                                        'hooks',
                                        {}
                                      )
                                  "
                                  :value="
                                    models[form.name][input.label][show.roles]
                                      .hooks
                                  "
                                  :item="
                                    models[form.name][input.label][show.roles]
                                      .hooks || {}
                                  "
                                />
                              </div>

                              <div class="sub-container">
                                <b>Permissions</b>
                                <div
                                  v-for="(permission, permissionkey) in models[
                                    form.name
                                  ][input.label][show.roles].permissions"
                                  :key="permissionkey"
                                >
                                  {{ permissionkey }}: {{ permission.type }}:
                                  {{ permission.validations }}
                                </div>
                                <input
                                  v-model="newInput['roles.permissions']"
                                  class="xs-font xs-input"
                                  type="text"
                                  placeholder="Add required field"
                                />
                                <button
                                  @click="
                                    models[form.name][input.label][
                                      show.roles
                                    ].permissions[
                                      newInput['roles.permissions']
                                    ] = { validations: [], type: '' };
                                    newInput['roles.permissions'] = '';
                                  "
                                  type="button"
                                  class="update xs-font p4 fa fa-plus"
                                ></button>
                              </div>
                              <div class="sub-container flex between">
                                <div
                                  class="flex"
                                  v-for="(member, memberid) in models[
                                    form.name
                                  ][input.label][show.roles].members"
                                  :key="memberid + show.roles"
                                >
                                  <user userid="memberid" />
                                  <a
                                    @click="
                                      models[form.name][input.label][
                                        show.roles
                                      ].members.splice(
                                        models[form.name][input.label][
                                          show.roles
                                        ].members.indexOf(memberid),
                                        1
                                      )
                                    "
                                    class="warn-text fa fa-times m4"
                                  ></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- MODULES -->
                        <div
                          class="p4 container b4"
                          v-if="input.inputType == 'modules'"
                        >
                          <div class="flex wrap flexy around">
                            <!-- MODULES -->
                            <div
                              class="xs-font b8 flex flexy wrap align-center"
                            >
                              <b class="r16">MODULES</b>
                              <span
                                @click="
                                  $set(models[form.name], input.label, [
                                    ...$store.state.modules,
                                  ])
                                "
                                class="xs-font"
                                >ALL</span
                              >
                              /
                              <span
                                @click="
                                  $set(models[form.name], input.label, [])
                                "
                                class="xs-font r16"
                                >NONE</span
                              >
                              <span class="xs-font"
                                >Enable or disable technologies</span
                              >
                              <div class="flex around wrap xs-font">
                                <div class="flex wrap around flexy p8">
                                  <span
                                    :class="
                                      models[form.name][input.label] &&
                                      models[form.name][input.label].indexOf(
                                        mod
                                      ) > -1
                                        ? 'update-text sm-font'
                                        : 'sm-font'
                                    "
                                    type="button"
                                    @click="
                                      models[form.name][input.label].indexOf(
                                        mod
                                      ) > -1
                                        ? models[form.name][input.label].splice(
                                            models[form.name][
                                              input.label
                                            ].indexOf(mod),
                                            1
                                          )
                                        : models[form.name][input.label].push(
                                            mod
                                          )
                                    "
                                    :key="mod"
                                    v-for="mod in $store.state.modules"
                                    class="p4 b4"
                                  >
                                    <i
                                      :class="`fas ${
                                        models[form.name][input.label] &&
                                        models[form.name][input.label].indexOf(
                                          mod
                                        ) > -1
                                          ? 'fa-check-square r4'
                                          : 'fa-square r4'
                                      };`"
                                    ></i>
                                    {{ mod.toUpperCase() }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- ITEMS -->
                        <div
                          class="flex p4 column b8"
                          v-if="input.inputType == 'items'"
                        >
                          <div class="flex">
                            <div class="flex">
                              <label class="xs-font flex">
                                <div class="flex between align-center">
                                  <div class="flex">
                                    <div class="flex align-center">
                                      <label for="items">
                                        <input
                                          :class="
                                            restrictedTypes.indexOf(
                                              newItem.norm()
                                            ) > -1 ||
                                            ($store.state.app.itemTypes &&
                                              $store.state.app.itemTypes.indexOf(
                                                newItem.norm()
                                              ) > -1)
                                              ? 'inputerror'
                                              : ''
                                          "
                                          class="r4 flexy xs-input xs-font"
                                          id="items"
                                          v-model="newItem"
                                          placeholder="Add item type"
                                        />
                                      </label>
                                      <button
                                        type="button"
                                        :disabled="
                                          newItem.length <= 2 ||
                                          restrictedTypes.indexOf(
                                            newItem.norm()
                                          ) > -1
                                        "
                                        class="success p4 xs-font"
                                        @click="
                                          models[form.name][input.label].push({
                                            name: newItem.norm(),
                                            type: newType,
                                            forms: [basicGroup],
                                          });
                                          newItem = '';
                                        "
                                      >
                                        <i class="fas fa-plus"></i>
                                        <span
                                          class="l4"
                                          v-if="newItem.length > 2"
                                          >Create item</span
                                        >
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </label>
                              <b
                                v-if="
                                  restrictedTypes.indexOf(newItem.norm()) > -1
                                "
                                class="xs-font container"
                              >
                                Sorry, the following item keyword is reserved:
                                {{ newItem }}
                              </b>
                              <b
                                v-if="
                                  $store.state.app.itemTypes &&
                                  $store.state.app.itemTypes.indexOf(
                                    newItem.norm()
                                  ) > -1
                                "
                                class="xs-font container"
                              >
                                This item type already exists: {{ newItem }}.
                                Please choose a unique name.
                              </b>
                            </div>
                          </div>
                          <span
                            v-if="
                              ($store.state.app.itemTypes &&
                                $store.state.app.itemTypes.length > 0) ||
                              models.basics.items
                            "
                            class="column flex flexy"
                          >
                            <div
                              :key="itemKey"
                              v-for="(item, itemKey) in models[form.name][
                                input.label
                              ]"
                              :class="
                                show.itemConfig[item.name] && 'update-border'
                              "
                              class="flex column wrap t4 container"
                            >
                              <div class="b4">
                                <div
                                  class="
                                    flex
                                    update
                                    align-center
                                    between
                                    container
                                    p4
                                  "
                                >
                                  <b
                                    @click="
                                      $set(
                                        show.itemConfig,
                                        item.name,
                                        !show.itemConfig[item.name]
                                      )
                                    "
                                    class="r8 bold"
                                  >
                                    <i
                                      class="r4"
                                      :class="
                                        show.itemConfig[item.name]
                                          ? 'fas fa-minus'
                                          : 'fas fa-plus'
                                      "
                                    ></i>
                                    {{ item.name }}
                                  </b>
                                  <div class="flex align-center p4 xs-font">
                                    <rm
                                      class="r16"
                                      :obj="models[form.name][input.label]"
                                      :name="itemKey"
                                    />
                                    <ilink
                                      class="white"
                                      mode="hidden"
                                      :to="`/list/${item.name}`"
                                      :label="item.name"
                                    />
                                  </div>
                                </div>
                                <!-- <input v-if="show.itemConfig[item.name]" v-model="models[form.name][input.label][itemKey].name"/> -->

                                <div
                                  v-if="show.itemConfig[item.name]"
                                  class="b8 p8 xs-font"
                                >
                                  <div
                                    v-if="
                                      $store.state.abilityTypes.indexOf(
                                        newForm[form.name + '-' + itemKey]
                                      ) > -1
                                    "
                                    class="xs-font"
                                  >
                                    Sorry,
                                    {{ newForm[form.name + "-" + itemKey] }} is
                                    a reserved keyword.
                                  </div>
                                  <div class="flex sm-font between">
                                    <b class="r8">Information Groups</b>
                                    <div
                                      class="flex wrap sm-font align-center b8"
                                    >
                                      <b
                                        v-if="
                                          !models.basics.items[itemKey]
                                            .abilities ||
                                          models.basics.items[itemKey].abilities
                                            .length !==
                                            $store.state.abilities.length
                                        "
                                        class="r8"
                                        >Add Ability</b
                                      >
                                      <select
                                        @change="
                                          !models.basics.items[itemKey]
                                            .abilities
                                            ? $set(
                                                models.basics.items[itemKey],
                                                'abilities',
                                                []
                                              )
                                            : null;
                                          show['addability' + itemKey] &&
                                            (models.basics.items[
                                              itemKey
                                            ].abilities.push(
                                              show['addability' + itemKey].name
                                            ),
                                            models.basics.items[
                                              itemKey
                                            ].forms.push(
                                              show['addability' + itemKey]
                                            ),
                                            $set(
                                              show.inputs,
                                              itemKey +
                                                '-' +
                                                show['addability' + itemKey]
                                                  .name +
                                                '-' +
                                                (models.basics.items[itemKey]
                                                  .forms.length -
                                                  1),
                                              !show.inputs[
                                                itemKey +
                                                  '-' +
                                                  show['addability' + itemKey]
                                                    .name +
                                                  '-' +
                                                  (models.basics.items[itemKey]
                                                    .forms.length -
                                                    1)
                                              ]
                                            ));
                                          $set(
                                            show,
                                            'addability' + itemKey,
                                            false
                                          );
                                        "
                                        v-model="show['addability' + itemKey]"
                                        :style="
                                          !show['addability' + itemKey] &&
                                          'width:24px'
                                        "
                                      >
                                        <option disabled="true" selected="true">
                                          Choose
                                        </option>
                                        <option
                                          :disabled="
                                            models.basics.items[itemKey]
                                              .abilities &&
                                            models.basics.items[itemKey]
                                              .abilities.length > 0 &&
                                            models.basics.items[
                                              itemKey
                                            ].abilities.indexOf(ability.name) >
                                              -1
                                          "
                                          :key="abilitykey"
                                          v-for="(ability, abilitykey) in $store
                                            .state.abilities"
                                          :value="ability"
                                        >
                                          <span>{{
                                            ability.name.toUpperCase()
                                          }}</span>
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="flex wrap">
                                    <div
                                      :key="itemformKey"
                                      v-for="(
                                        itemform, itemformKey
                                      ) in item.forms"
                                      class="
                                        flexy
                                        p4
                                        container
                                        flex
                                        column
                                        between
                                      "
                                    >
                                      <div
                                        class="
                                          flex
                                          between
                                          wrap
                                          align-center
                                          sm-font
                                        "
                                      >
                                        <b
                                          @click="
                                            $set(
                                              show.inputs,
                                              itemKey +
                                                '-' +
                                                itemform.name +
                                                '-' +
                                                itemformKey,
                                              !show.inputs[
                                                itemKey +
                                                  '-' +
                                                  itemform.name +
                                                  '-' +
                                                  itemformKey
                                              ]
                                            )
                                          "
                                          class="r4"
                                        >
                                          <i
                                            class="r4"
                                            :class="
                                              show.inputs[
                                                itemKey +
                                                  '-' +
                                                  itemform.name +
                                                  '-' +
                                                  itemformKey
                                              ]
                                                ? 'far fa-minus-square'
                                                : 'far fa-plus-square'
                                            "
                                          ></i>
                                          {{ itemform.name.toUpperCase() }}
                                        </b>
                                        <!-- <rm :obj="item.forms" :name="formKey" /> -->
                                        <div
                                          class="flex align-center xs-font"
                                          v-if="show.remove[itemform.name]"
                                        >
                                          <button
                                            type="button"
                                            @click="
                                              item.forms.splice(itemformKey, 1);
                                              models.basics.items[itemKey]
                                                .abilities &&
                                              models.basics.items[
                                                itemKey
                                              ].abilities.includes(
                                                itemform.name
                                              )
                                                ? models.basics.items[
                                                    itemKey
                                                  ].abilities.splice(
                                                    models.basics.items[
                                                      itemKey
                                                    ].abilities.indexOf(
                                                      itemform.name
                                                    ),
                                                    1
                                                  )
                                                : null;
                                              $set(
                                                show.remove,
                                                itemform.name,
                                                !show.remove[itemform.name]
                                              );
                                            "
                                            class="warn r4 p4"
                                            v-if="show.remove[itemform.name]"
                                          >
                                            <span class="sm-font">
                                              <i class="fa fa-trash r4"></i
                                              >Confirm
                                            </span>
                                          </button>
                                          <a
                                            @click="
                                              $set(
                                                show.remove,
                                                itemform.name,
                                                !show.remove[itemform.name]
                                              )
                                            "
                                            >Cancel</a
                                          >
                                        </div>

                                        <code
                                          v-else
                                          @click="
                                            $set(
                                              show.remove,
                                              itemform.name,
                                              !show.remove[itemform.name]
                                            )
                                          "
                                          type="button"
                                          class="warn-text flex xs-font p8"
                                        >
                                          <i class="fa fa-trash r4"></i>
                                        </code>
                                      </div>
                                      <div
                                        class
                                        :key="inputKey"
                                        v-for="(input, inputKey) in orderBy(
                                          itemform.inputs,
                                          'priority'
                                        )"
                                      >
                                        <div
                                          v-if="
                                            show.inputs[
                                              itemKey +
                                                '-' +
                                                itemform.name +
                                                '-' +
                                                itemformKey
                                            ]
                                          "
                                        >
                                          <div
                                            class
                                            :class="
                                              show.inputs[
                                                itemKey +
                                                  '-' +
                                                  itemform.name +
                                                  '-' +
                                                  itemformKey +
                                                  '-' +
                                                  inputKey
                                              ]
                                                ? 'container p4 b8'
                                                : 'border-bottom'
                                            "
                                          >
                                            <div
                                              class="flex between align-center"
                                            >
                                              <span
                                                @click="
                                                  $set(
                                                    show.inputs,
                                                    itemKey +
                                                      '-' +
                                                      itemform.name +
                                                      '-' +
                                                      itemformKey +
                                                      '-' +
                                                      inputKey,
                                                    !show.inputs[
                                                      itemKey +
                                                        '-' +
                                                        itemform.name +
                                                        '-' +
                                                        itemformKey +
                                                        '-' +
                                                        inputKey
                                                    ]
                                                  )
                                                "
                                              >
                                                <i
                                                  :class="
                                                    show.inputs[
                                                      itemKey +
                                                        '-' +
                                                        itemform.name +
                                                        '-' +
                                                        itemformKey +
                                                        '-' +
                                                        inputKey
                                                    ]
                                                      ? 'fas fa-minus-square'
                                                      : 'fas fa-plus-square'
                                                  "
                                                  class="r8 xs-font"
                                                ></i>
                                                <b>{{ input.label }}</b>
                                              </span>
                                              <div class="flex align-center">
                                                <div
                                                  class="
                                                    flex
                                                    align-center
                                                    around
                                                  "
                                                >
                                                  {{
                                                    typeof input.display !==
                                                    "object"
                                                      ? Object.entries(
                                                          item.forms[
                                                            itemformKey
                                                          ]
                                                        ).map((x) =>
                                                          $set(
                                                            input,
                                                            "display",
                                                            {
                                                              list: true,
                                                              single: true,
                                                              form: true,
                                                            }
                                                          )
                                                        )
                                                      : null
                                                  }}
                                                  <!-- <button type="button" class="xs-font" @click="Object.entries(item.forms[formKey]).map((x)=>$set(x[1].inputs[inputKey],'display', true))">All</button> -->
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      v-model="
                                                        input.display.single
                                                      "
                                                    />Single
                                                  </label>
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      v-model="
                                                        input.display.list
                                                      "
                                                    />List
                                                  </label>
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      v-model="
                                                        input.display.form
                                                      "
                                                    />Form
                                                  </label>
                                                </div>
                                                <div class="flex center">
                                                  <rm
                                                    class="m4"
                                                    :name="inputKey"
                                                    :obj="itemform.inputs"
                                                  />
                                                  <select
                                                    v-model="input.priority"
                                                  >
                                                    <option
                                                      :key="priorityKey"
                                                      v-for="(
                                                        priority, priorityKey
                                                      ) in itemform.inputs
                                                        .length"
                                                      :value="priority"
                                                    >
                                                      {{ priority }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              v-if="
                                                show.inputs[
                                                  itemKey +
                                                    '-' +
                                                    itemform.name +
                                                    '-' +
                                                    itemformKey +
                                                    '-' +
                                                    inputKey
                                                ]
                                              "
                                              class="flex column"
                                            >
                                              <div class="flex column wrap">
                                                <label for="label"
                                                  >Input Name</label
                                                >
                                                <input
                                                  class="xs-input xs-font"
                                                  id="label"
                                                  type="text"
                                                  v-model="input.label"
                                                />
                                                <br />
                                              </div>
                                              <div class="flex column wrap">
                                                <label for="input-element"
                                                  >Input Element</label
                                                >
                                                <select
                                                  id="input-element"
                                                  v-model="input.inputType"
                                                >
                                                  <option
                                                    :key="optKey"
                                                    v-for="(opt, optKey) in [
                                                      'input',
                                                      'textarea',
                                                      'check',
                                                      'tags',
                                                      'select',
                                                      'select-nested',
                                                      'date-time',
                                                      'file',
                                                      'button',
                                                    ]"
                                                  >
                                                    {{ opt }}
                                                  </option>
                                                </select>
                                                <br />
                                              </div>
                                              <div
                                                class="flex column wrap"
                                                v-if="
                                                  input.inputType ===
                                                    'select' ||
                                                  input.inputType === 'check' ||
                                                  input.inputType === 'select-nested'
                                                "
                                              >
                                                <h4>Select Options</h4>
                                                <!-- <div>Multiple Choice? <input type="checkbox" v-model="input.multiple"></div> -->
                                                <div
                                                  :key="optionKey"
                                                  v-for="(
                                                    option, optionKey
                                                  ) in input.options"
                                                  class="flex wrap"
                                                >
                                                  <input
                                                    class="xs-font"
                                                    type="text"
                                                    v-model="
                                                      input.options[optionKey]
                                                    "
                                                    :placeholder="`Option ${
                                                      optionKey + 1
                                                    }`"
                                                  />
                                                  <code
                                                    class="xs-font p8 warn-text"
                                                    type="button"
                                                    @click="
                                                      input.options.splice(
                                                        optionKey,
                                                        1
                                                      )
                                                    "
                                                  >
                                                    <i class="fa fa-trash"></i>
                                                  </code>
                                                </div>
                                                <br />
                                                <button
                                                  type="button"
                                                  @click="
                                                    input.options.push('')
                                                  "
                                                >
                                                  Add another option
                                                </button>
                                                <br />
                                              </div>
                                              <div
                                                class="flex column wrap b16"
                                                v-if="input.inputType === 'select-nested'"
                                              >
                                                <h4>Nested Model Properties</h4>
                                                <div class="xs-font b8">
                                                  Define the properties for nested objects. Each selected option will have an array of objects with these properties.
                                                </div>
                                                <div
                                                  :key="propKey"
                                                  v-for="(propValue, propKey) in (input.nestedModel || {})"
                                                  class="flex wrap align-center b4"
                                                >
                                                  <input
                                                    class="xs-font"
                                                    type="text"
                                                    :value="propKey"
                                                    @blur="
                                                      const oldKey = propKey;
                                                      const newKey = $event.target.value.trim();
                                                      if (newKey && newKey !== oldKey && newKey !== '') {
                                                        const newModel = {};
                                                        Object.keys(input.nestedModel).forEach(k => {
                                                          if (k === oldKey) {
                                                            newModel[newKey] = input.nestedModel[oldKey];
                                                          } else {
                                                            newModel[k] = input.nestedModel[k];
                                                          }
                                                        });
                                                        $set(input, 'nestedModel', newModel);
                                                      } else if (newKey === '' || newKey === oldKey) {
                                                        $event.target.value = oldKey;
                                                      }
                                                    "
                                                    @keyup.enter="$event.target.blur()"
                                                    placeholder="Property name"
                                                  />
                                                  <select
                                                    class="xs-font"
                                                    @change="
                                                      const value = $event.target.value;
                                                      if (value === 'string') {
                                                        input.nestedModel[propKey] = '';
                                                      } else if (value === 'number') {
                                                        input.nestedModel[propKey] = 0;
                                                      } else {
                                                        input.nestedModel[propKey] = '';
                                                      }
                                                    "
                                                  >
                                                    <option :value="typeof input.nestedModel[propKey] === 'number' ? 'number' : 'string'" selected>
                                                      {{ typeof input.nestedModel[propKey] === 'number' ? 'number' : 'string' }}
                                                    </option>
                                                    <option value="string">string</option>
                                                    <option value="number">number</option>
                                                  </select>
                                                  <input
                                                    v-if="typeof input.nestedModel[propKey] === 'number'"
                                                    class="xs-font"
                                                    type="number"
                                                    v-model.number="input.nestedModel[propKey]"
                                                    placeholder="Default number"
                                                  />
                                                  <input
                                                    v-else
                                                    class="xs-font"
                                                    type="text"
                                                    v-model="input.nestedModel[propKey]"
                                                    placeholder="Default value"
                                                  />
                                                  <code
                                                    class="xs-font p8 warn-text"
                                                    type="button"
                                                    @click="
                                                      $delete(input.nestedModel, propKey)
                                                    "
                                                  >
                                                    <i class="fa fa-trash"></i>
                                                  </code>
                                                </div>
                                                <button
                                                  type="button"
                                                  @click="
                                                    if (!input.nestedModel) {
                                                      $set(input, 'nestedModel', {});
                                                    } else {
                                                      const newKey = 'newProperty' + Date.now();
                                                      const newModel = Object.assign({}, input.nestedModel);
                                                      newModel[newKey] = '';
                                                      $set(input, 'nestedModel', newModel);
                                                    }
                                                  "
                                                >
                                                  Add Property
                                                </button>
                                              </div>
                                              <div
                                                class="flex column"
                                                v-if="
                                                  input.inputType === 'input'
                                                "
                                              >
                                                <label for="input-type"
                                                  >Input Type</label
                                                >
                                                <input
                                                  class="xs-font"
                                                  id="input-type"
                                                  type="text"
                                                  v-model="input.type"
                                                />
                                                <br />
                                              </div>
                                              <div class="flex column">
                                                <label for="placeholder">
                                                  Placeholder / Entry directions
                                                </label>
                                                <input
                                                  class="xs-font"
                                                  id="placeholder"
                                                  type="text"
                                                  v-model="input.placeholder"
                                                />
                                                <br />
                                                <label
                                                  :for="`items-${input.inputType}-required`"
                                                >
                                                  <input
                                                    v-if="
                                                      input.inputType ===
                                                      'check'
                                                    "
                                                    type="checkbox"
                                                    v-model="input.required"
                                                  />Required
                                                </label>
                                              </div>
                                              <div
                                                class="flex align-center b16"
                                              >
                                                <label for="default"
                                                  >Default Value</label
                                                >

                                                <span
                                                  v-if="
                                                    input.inputType !==
                                                      'select' &&
                                                    input.inputType !==
                                                      'check' &&
                                                    input.inputType !==
                                                      'tags' &&
                                                    input.inputType !==
                                                      'select-nested' &&
                                                    input.inputType !==
                                                      'date-time'
                                                  "
                                                >
                                                  <input
                                                    class="xs-font"
                                                    id="default"
                                                    type="text"
                                                    v-model="input.default"
                                                    placeholder="What value should this default to?"
                                                  />
                                                </span>

                                                <div
                                                  v-if="
                                                    input.inputType === 'tags'
                                                  "
                                                >
                                                  Tags default to an empty list.
                                                </div>
                                                <div
                                                  v-if="
                                                    input.inputType === 'select-nested'
                                                  "
                                                >
                                                  Select-nested defaults to an empty object. Each selected option will have its own array of nested objects.
                                                </div>
                                                <input
                                                  v-if="
                                                    input.inputType === 'check'
                                                  "
                                                  type="checkbox"
                                                  v-model="input.default"
                                                />
                                                <select
                                                  id="default"
                                                  v-model="input.default"
                                                  v-if="
                                                    input.inputType === 'select'
                                                  "
                                                >
                                                  <option
                                                    :value="opti"
                                                    :key="optiKey"
                                                    v-for="(
                                                      opti, optiKey
                                                    ) in input.options"
                                                  >
                                                    {{ opti }}
                                                  </option>
                                                </select>
                                                {{ input.default }}
                                              </div>
                                              <button
                                                v-if="
                                                  input.if &&
                                                  input.if.length == 0
                                                "
                                                type="button"
                                                @click="
                                                  !input.if[0]
                                                    ? $set(input.if, 0, {})
                                                    : null;
                                                  $set(
                                                    show,
                                                    thisform.name +
                                                      itemform.name +
                                                      input.label,
                                                    !show[
                                                      thisform.name +
                                                        itemform.name +
                                                        input.label
                                                    ]
                                                  );
                                                "
                                              >
                                                Set Conditions
                                              </button>
                                              <div
                                                v-if="
                                                  show[
                                                    thisform.name +
                                                      itemform.name +
                                                      input.label
                                                  ] ||
                                                  (input.if &&
                                                    input.if.length > 0)
                                                "
                                              >
                                                <b>Conditions</b>
                                                <row
                                                  class="container p4 b4"
                                                  w
                                                  :key="
                                                    condi + 'inputcondition'
                                                  "
                                                  v-for="(
                                                    cond, condi
                                                  ) in input.if"
                                                >
                                                  {{ condi + 1 }}
                                                  <label
                                                    :for="`${itemform.name}input-if-key`"
                                                    >Key:
                                                    <select v-model="cond.key">
                                                      <option
                                                        :key="forminputkey"
                                                        v-for="forminputkey in item.forms.map(
                                                          (x) => x.name
                                                        )"
                                                        :value="forminputkey"
                                                      >
                                                        {{ forminputkey }}
                                                      </option>
                                                    </select>
                                                  </label>
                                                  <label
                                                    v-if="cond.key"
                                                    :for="`${itemform.name}input-if-prop`"
                                                    >Key:
                                                    <select v-model="cond.prop">
                                                      <option
                                                        :key="forminputprop"
                                                        v-for="forminputprop in item.forms[
                                                          item.forms.findIndex(
                                                            (x) =>
                                                              x.name ===
                                                              cond.key
                                                          )
                                                        ].inputs.map(
                                                          (x) => x.label
                                                        )"
                                                        :value="forminputprop"
                                                      >
                                                        {{ forminputprop }}
                                                      </option>
                                                    </select>
                                                  </label>
                                                  Value:
                                                  <iinput
                                                    :id="`${itemform.name}input-if-value`"
                                                    v-model="cond.value"
                                                    placeholder="Enter form conditional"
                                                  />
                                                  Advanced Conditions
                                                  <if :item="cond" />
                                                  <rm
                                                    :obj="input.if"
                                                    :name="condi"
                                                  />
                                                </row>
                                                <button
                                                  @click="
                                                    $set(
                                                      input.if,
                                                      input.if.length,
                                                      {}
                                                    )
                                                  "
                                                  type="button"
                                                >
                                                  Add another condition
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        v-if="
                                          show.inputs[
                                            itemKey +
                                              '-' +
                                              itemform.name +
                                              '-' +
                                              itemformKey
                                          ]
                                        "
                                        class="flex align-start wrap p4 xs-font"
                                      >
                                        <input
                                          id="add-input"
                                          class="xs-font xs-input flexy r4"
                                          v-model="newInput[itemform.name]"
                                          placeholder="Add an input property"
                                          type="text"
                                        />
                                        <button
                                          :disabled="
                                            newInput[itemform.name] &&
                                            newInput[itemform.name].length < 2
                                          "
                                          type="button"
                                          :class="
                                            newInput[itemform.name] &&
                                            newInput[itemform.name].length < 2
                                              ? ''
                                              : 'update'
                                          "
                                          class="p4 fit"
                                          @click="
                                            itemform.inputs.push({
                                              display: {
                                                list: true,
                                                single: true,
                                                form: true,
                                              },
                                              label: newInput[itemform.name],
                                              inputType: 'input',
                                              type: 'text',
                                              placeholder:
                                                newInput[itemform.name] +
                                                ' text',
                                              default: '',
                                              disabled: false,
                                              options: [''],
                                              priority: 5,
                                              if: [],
                                            });
                                            newInput[itemform.name] = '';
                                            show.inputs[
                                              itemKey +
                                                '-' +
                                                itemform.name +
                                                '-' +
                                                itemformKey
                                            ] = true;
                                          "
                                        >
                                          <i class="fas fa-plus fa-xs p4"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex align-start wrap p8 xs-font">
                                    <input
                                      :class="
                                        $store.state.abilityTypes.indexOf(
                                          newForm[form.name + '-' + itemKey]
                                        ) > -1
                                          ? 'inputerror'
                                          : ''
                                      "
                                      class="xs-font xs-input flexy r4"
                                      v-model="
                                        newForm[form.name + '-' + itemKey]
                                      "
                                      type="text"
                                      placeholder="Add a property group"
                                    />
                                    <button
                                      :disabled="
                                        $store.state.abilityTypes.indexOf(
                                          newForm[form.name + '-' + itemKey]
                                        ) > -1 ||
                                        (newForm[form.name + '-' + itemKey] &&
                                          newForm[form.name + '-' + itemKey]
                                            .length < 2)
                                      "
                                      type="button"
                                      class="update fit p4"
                                      @click="
                                        item.forms.push({
                                          name: newForm[
                                            form.name + '-' + itemKey
                                          ],
                                          inputs: [],
                                        });
                                        newForm[form.name + '-' + itemKey] = '';
                                      "
                                    >
                                      <i class="fas fa-plus fa-xs p4"></i>
                                    </button>
                                  </div>
                                </div>
                                <div
                                  v-if="show.itemConfig[item.name]"
                                  class="flex p8 fill xs-font wrap"
                                >
                                  <div itemoptions class="flex column">
                                    <div
                                      @click="
                                        $set(
                                          models[form.name][input.label][
                                            itemKey
                                          ],
                                          'crowd allowed',
                                          !models[form.name][input.label][
                                            itemKey
                                          ]['crowd allowed']
                                        )
                                      "
                                      class="xs-font"
                                    >
                                      <i
                                        :class="`r4 fas fa-${
                                          models[form.name][input.label][
                                            itemKey
                                          ]['crowd allowed']
                                            ? 'check-'
                                            : ''
                                        }square`"
                                      ></i>
                                      Users can create {{ item.name }}
                                    </div>
                                    <div
                                      @click="
                                        $set(
                                          models[form.name][input.label][
                                            itemKey
                                          ],
                                          'comments',
                                          !models[form.name][input.label][
                                            itemKey
                                          ]['comments']
                                        )
                                      "
                                      class="xs-font"
                                    >
                                      <i
                                        :class="`r4 fas fa-${
                                          models[form.name][input.label][
                                            itemKey
                                          ]['comments']
                                            ? 'check-'
                                            : ''
                                        }square`"
                                      ></i>
                                      Comments
                                    </div>
                                    <div
                                      @click="
                                        $set(
                                          models[form.name][input.label][
                                            itemKey
                                          ],
                                          'reputation',
                                          !models[form.name][input.label][
                                            itemKey
                                          ]['reputation']
                                        )
                                      "
                                      class="xs-font"
                                    >
                                      <i
                                        :class="`r4 fas fa-${
                                          models[form.name][input.label][
                                            itemKey
                                          ]['reputation']
                                            ? 'check-'
                                            : ''
                                        }square`"
                                      ></i>
                                      Reputation
                                    </div>
                                    <span
                                      chooseicon
                                      :class="
                                        chooseIcon[itemKey] ? 'update-text' : ''
                                      "
                                      @click="
                                        $set(chooseAbility, itemKey, false);
                                        $set(
                                          chooseIcon,
                                          itemKey,
                                          !chooseIcon[itemKey]
                                        );
                                      "
                                    >
                                      <i
                                        class="fas fa-caret-down fa-xs"
                                        style="align-self: flex-start"
                                      ></i
                                      >Choose Icon
                                    </span>
                                    <div v-if="chooseIcon[itemKey]" class>
                                      <input
                                        class="xs-font xs-input"
                                        type="text"
                                        v-model="searchIcon"
                                        placeholder="Search icons"
                                      />
                                      <div class="flex wrap column">
                                        <div class="flex wrap">
                                          <span
                                            :key="iconKey"
                                            v-for="(icon, iconKey) in $store
                                              .state.icons.fulllist"
                                          >
                                            <span
                                              @click="$set(item, 'icon', icon)"
                                              class="m4"
                                              :class="icon"
                                              v-if="
                                                searchIcon.length === 0 ||
                                                (searchIcon.length > 0 &&
                                                  icon.indexOf(searchIcon) > -1)
                                              "
                                            ></span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <input
                                      submittext
                                      type="text"
                                      class="xs-input xs-font"
                                      placeholder="Submit button text"
                                      v-model="
                                        models[form.name][input.label][itemKey][
                                          'submit button text'
                                        ]
                                      "
                                    />
                                  </div>
                                  <div class="flex">
                                    <b>
                                      <i class="fa fa-fish"></i>
                                    </b>
                                    <div class="flex column">
                                      <div
                                        :class="
                                          show[
                                            'hooks' +
                                              input.label +
                                              '_' +
                                              item.name +
                                              hooktype
                                          ]
                                            ? 'update-border m4'
                                            : 'm4'
                                        "
                                        v-for="hooktype in [
                                          'list',
                                          'item',
                                          'create',
                                        ]"
                                        :key="hooktype"
                                      >
                                        <b
                                          class="label"
                                          :class="
                                            item.hooks &&
                                            item.hooks[hooktype] &&
                                            item.hooks[hooktype].fun
                                              ? 'update'
                                              : ''
                                          "
                                          @click="
                                            !item.hooks
                                              ? $set(item, 'hooks', {})
                                              : null;
                                            !item.hooks[hooktype]
                                              ? $set(item.hooks, hooktype, {})
                                              : null;
                                            $set(
                                              show,
                                              'hooks' +
                                                input.label +
                                                '_' +
                                                item.name +
                                                hooktype,
                                              !show[
                                                'hooks' +
                                                  input.label +
                                                  '_' +
                                                  item.name +
                                                  hooktype
                                              ]
                                            );
                                          "
                                        >
                                          <i
                                            :class="`r4 fa fa-${
                                              show[
                                                'hooks' +
                                                  input.label +
                                                  '_' +
                                                  item.name +
                                                  hooktype
                                              ]
                                                ? 'minus'
                                                : 'plus'
                                            }`"
                                          ></i>
                                          {{ hooktype }}
                                        </b>
                                        <hooks
                                          v-if="
                                            item.hooks &&
                                            item.hooks[hooktype] &&
                                            show[
                                              'hooks' +
                                                input.label +
                                                '_' +
                                                item.name +
                                                hooktype
                                            ]
                                          "
                                          :props="['id', 'type']"
                                          :name="input.label + '_' + item.name"
                                          :value="item.hooks[hooktype]"
                                          :item="item.hooks[hooktype]"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </span>
                        </div>

                        <!-- CONTRACTS -->
                        <smartcontract
                          v-if="input.inputType === 'smartcontract'"
                        />

                        <!-- SELECT -->
                        <div
                          :required="input.required"
                          class="flex wrap align-center md-font around"
                          v-if="input.inputType == 'select' && !input.multiple"
                        >
                          <div
                            :style="
                              (models[form.name][input.label] === option.name ||
                                models[form.name][input.label] === option) &&
                              option.content
                                ? 'order: 1'
                                : ''
                            "
                            :class="`${
                              models[form.name][input.label] === option.name ||
                              models[form.name][input.label] === option
                                ? 'update-text'
                                : 'xs-font p8'
                            } ${
                              (models[form.name][input.label] === option.name ||
                                models[form.name][input.label] === option) &&
                              option.content
                                ? 'fill p8'
                                : ''
                            }`"
                            class="flex wrap"
                            @click="
                              models[form.name][input.label] === option.name ||
                              models[form.name][input.label] === option
                                ? (models[form.name][input.label] = '')
                                : (models[form.name][input.label] =
                                    option.name || option);
                              input.required
                                ? (required[form.name][input.label] = true)
                                : null;
                              option.dispatch
                                ? $store.dispatch(
                                    option.dispatch,
                                    option.payload
                                  )
                                : void 0;
                            "
                            v-for="(option, optionKey) in input.options"
                            :key="optionKey"
                          >
                            <div class="align-center flexy flex">
                              <img
                                class="r4"
                                :style="
                                  models[form.name][input.label] ===
                                    option.name ||
                                  models[form.name][input.label] === option
                                    ? 'height: 16px; width: 16px; '
                                    : 'height: 12px; width: 12px; ' +
                                      'background: #fff; border: 1px solid #fff; border-radius: 100%'
                                "
                                v-if="option.image"
                                :src="option.image"
                              />
                              <i
                                :style="`color: ${$store.state.app.style.color}`"
                                v-if="option.icon"
                                :class="option.icon"
                                class="r4"
                              ></i>
                              {{ option.name || option }}
                            </div>
                            <code
                              v-html="option.content"
                              class="xs-font flexy flex column align-end"
                              v-if="
                                option.name &&
                                models[form.name][input.label] ===
                                  option.name &&
                                option.content
                              "
                            ></code>
                          </div>
                        </div>

                        <!-- Select Multiple  -->
                        <div
                          :required="input.required"
                          class="flex wrap align-center md-font around"
                          v-if="input.inputType == 'select' && input.multiple"
                        >
                          <div
                            :class="
                              models[form.name] &&
                              models[form.name][input.label] &&
                              Array.isArray(models[form.name][input.label]) &&
                              models[form.name][input.label].indexOf(
                                option && option.name ? option.name : option
                              ) > -1
                                ? 'update-text'
                                : ''
                            "
                            class="flex center r8 xs-font"
                            @click="
                              if (!models[form.name]) {
                                $set(models, form.name, {});
                              }
                              if (!models[form.name][input.label]) {
                                $set(models[form.name], input.label, []);
                              }
                              input.multiple // multiple is true
                                ? models[form.name][input.label].indexOf(
                                    option && option.name ? option.name : option
                                  ) === -1 // item does not exist
                                  ? (models[form.name][input.label].push(
                                      option.name || option
                                    ),
                                    !models[form.name]['component props']
                                      ? $set(models[form.name], 'component props', {})
                                      : null,
                                    !models[form.name]['component props'][
                                      option.name
                                    ]
                                      ? (models[form.name]['component props'][
                                          option.name
                                        ] = {})
                                      : null)
                                  : models[form.name][input.label].splice(
                                      models[form.name][input.label].indexOf(
                                        option && option.name
                                          ? option.name
                                          : option
                                      ),
                                      1
                                    ) // otherwise remove
                                : (models[form.name][input.label] =
                                    option && option.name
                                      ? option.name
                                      : option);
                              input.required
                                ? (required[form.name][input.label] = true)
                                : null;
                            "
                            v-for="(option, optionKey) in input.options"
                            :key="optionKey"
                          >
                            <i
                              v-if="option.icon"
                              :class="option.icon"
                              class="r4"
                            ></i>
                            {{ option && option.name ? option.name : option }}
                          </div>
                        </div>

                        <!-- SELECT-NESTED -->
                        <div
                          :required="input.required"
                          class="flex column wrap b16"
                          v-if="input.inputType == 'select-nested'"
                        >
                          <!-- Option Selection -->
                          <div class="flex wrap align-center md-font around b8">
                            <div
                              v-if="!input.options || input.options.length === 0"
                              class="xs-font p8"
                            >
                              No options configured. Add options in the form configuration.
                            </div>
                            <div
                              :class="
                                models[form.name][input.label] &&
                                Object.keys(models[form.name][input.label]).indexOf(
                                  option && option.name ? option.name : option
                                ) > -1
                                  ? 'update-text'
                                  : ''
                              "
                              class="flex center align-center r8 xs-font p8 border"
                              @click="
                                !models[form.name][input.label]
                                  ? $set(models[form.name], input.label, {})
                                  : null;
                                const optionName = option && option.name ? option.name : option;
                                const optionKey = optionName;
                                if (models[form.name][input.label] && models[form.name][input.label][optionKey]) {
                                  // Remove option and its nested array
                                  $delete(models[form.name][input.label], optionKey);
                                  // Also remove from defaults if it exists
                                  if (models[form.name][input.label + '_defaults']) {
                                    $delete(models[form.name][input.label + '_defaults'], optionKey);
                                  }
                                  // Force reactivity update
                                  $set(models[form.name], input.label, Object.assign({}, models[form.name][input.label]));
                                } else {
                                  // Add option with empty array
                                  $set(models[form.name][input.label], optionKey, []);
                                }
                                input.required
                                  ? (required[form.name][input.label] = true)
                                  : null;
                              "
                              v-for="(option, optionKey) in input.options"
                              :key="optionKey"
                            >
                              <div
                                class="flex center align-center"
                                @click.stop="
                                  !models[form.name][input.label]
                                    ? $set(models[form.name], input.label, {})
                                    : null;
                                  const optionName = option && option.name ? option.name : option;
                                  const optionKey = optionName;
                                  if (models[form.name][input.label] && models[form.name][input.label][optionKey]) {
                                    // Remove option and its nested array
                                    $delete(models[form.name][input.label], optionKey);
                                    // Also remove from defaults if it exists
                                    if (models[form.name][input.label + '_defaults']) {
                                      $delete(models[form.name][input.label + '_defaults'], optionKey);
                                    }
                                    // Remove priority
                                    if (models[form.name][input.label + '_priorities']) {
                                      $delete(models[form.name][input.label + '_priorities'], optionKey);
                                    }
                                    // Force reactivity update
                                    $set(models[form.name], input.label, Object.assign({}, models[form.name][input.label]));
                                  } else {
                                    // Add option with empty array
                                    if (!models[form.name][input.label]) {
                                      $set(models[form.name], input.label, {});
                                    }
                                    $set(models[form.name][input.label], optionKey, []);
                                    // Initialize priority if not exists
                                    if (!models[form.name][input.label + '_priorities']) {
                                      $set(models[form.name], input.label + '_priorities', {});
                                    }
                                    if (!models[form.name][input.label + '_priorities'][optionKey]) {
                                      $set(models[form.name][input.label + '_priorities'], optionKey, 0);
                                    }
                                  }
                                  input.required
                                    ? (required[form.name][input.label] = true)
                                    : null;
                                "
                              >
                                <i
                                  v-if="option.icon"
                                  :class="option.icon"
                                  class="r4"
                                ></i>
                                {{ option && option.name ? option.name : option }}
                              </div>
                              <input
                                v-if="models[form.name][input.label] && Object.keys(models[form.name][input.label] || {}).indexOf(option && option.name ? option.name : option) > -1"
                                type="number"
                                class="xs-font xs-input"
                                style="width: 60px; margin-left: 8px;"
                                :value="models[form.name][input.label + '_priorities'] && models[form.name][input.label + '_priorities'][option && option.name ? option.name : option] !== undefined ? models[form.name][input.label + '_priorities'][option && option.name ? option.name : option] : 0"
                                @input="
                                  const optionName = option && option.name ? option.name : option;
                                  if (!models[form.name][input.label + '_priorities']) {
                                    $set(models[form.name], input.label + '_priorities', {});
                                  }
                                  $set(models[form.name][input.label + '_priorities'], optionName, parseInt($event.target.value) || 0);
                                "
                                @click.stop
                                placeholder="Priority"
                              />
                            </div>
                          </div>

                          <!-- Nested Arrays for Each Selected Option -->
                          <div
                            v-for="(selectedOption, optKey) in Object.keys(
                              models[form.name][input.label] || {}
                            ).sort((a, b) => {
                              const priorities = models[form.name][input.label + '_priorities'] || {};
                              const priorityA = priorities[a] !== undefined ? priorities[a] : 0;
                              const priorityB = priorities[b] !== undefined ? priorities[b] : 0;
                              return priorityA - priorityB;
                            })"
                            :key="optKey"
                            class="flex column b16 p8 border"
                          >
                            <div class="flex between align-center b8">
                              <b class="xs-font">{{ selectedOption }}</b>
                              <button
                                type="button"
                                class="xs-font button"
                                @click.stop="
                                  const optionKey = selectedOption;
                                  let nestedArray = models[form.name][input.label][optionKey];
                                  if (!Array.isArray(nestedArray)) {
                                    nestedArray = [];
                                  }
                                  const newItem = {};
                                  Object.keys(input.nestedModel || {}).forEach((prop) => {
                                    const defaultValue = input.nestedModel[prop];
                                    newItem[prop] = typeof defaultValue === 'object' && defaultValue !== null
                                      ? JSON.parse(JSON.stringify(defaultValue))
                                      : defaultValue !== undefined
                                      ? defaultValue
                                      : '';
                                  });
                                  nestedArray.push(newItem);
                                  $set(models[form.name][input.label], optionKey, nestedArray);
                                "
                              >
                                <i class="fa fa-plus r4"></i> Add {{ selectedOption }}
                              </button>
                            </div>

                            <div
                              v-for="(item, itemIndex) in (Array.isArray(models[form.name][input.label][selectedOption]) ? models[form.name][input.label][selectedOption] : [])"
                              :key="itemIndex"
                              class="flex column wrap b8 p8 border"
                            >
                              <div class="flex between align-center b4">
                                <div class="flex align-center">
                                  <b class="xs-font r4">{{ selectedOption }} #{{ itemIndex + 1 }}</b>
                                  <label class="flex align-center xs-font" @click.stop>
                                    <input
                                      type="checkbox"
                                      :checked="models[form.name][input.label + '_defaults'] && models[form.name][input.label + '_defaults'][selectedOption] === itemIndex"
                                      @change="
                                        const defaultsKey = input.label + '_defaults';
                                        if (!models[form.name][defaultsKey]) {
                                          $set(models[form.name], defaultsKey, {});
                                        }
                                        if ($event.target.checked) {
                                          // Uncheck all other variations of the same type
                                          Object.keys(models[form.name][input.label] || {}).forEach(optKey => {
                                            if (optKey === selectedOption) {
                                              // For the same variation type, uncheck all others
                                              if (models[form.name][defaultsKey][optKey] !== undefined && models[form.name][defaultsKey][optKey] !== itemIndex) {
                                                $set(models[form.name][defaultsKey], optKey, itemIndex);
                                              } else {
                                                $set(models[form.name][defaultsKey], optKey, itemIndex);
                                              }
                                            }
                                          });
                                          $set(models[form.name][defaultsKey], selectedOption, itemIndex);
                                        } else {
                                          $set(models[form.name][defaultsKey], selectedOption, undefined);
                                        }
                                      "
                                    />
                                    <span class="xs-font r4">Default</span>
                                  </label>
                                </div>
                                <button
                                  type="button"
                                  class="xs-font button red"
                                  @click="
                                    const optionKey = selectedOption;
                                    const nestedArray = models[form.name][input.label][optionKey];
                                    // Ensure nestedArray is actually an array
                                    if (!Array.isArray(nestedArray)) {
                                      console.error('Variation data is not an array:', nestedArray);
                                      return;
                                    }
                                    // Remove default if this item was the default
                                    if (models[form.name][input.label + '_defaults'] && models[form.name][input.label + '_defaults'][optionKey] === itemIndex) {
                                      $delete(models[form.name][input.label + '_defaults'], optionKey);
                                    } else if (models[form.name][input.label + '_defaults'] && models[form.name][input.label + '_defaults'][optionKey] > itemIndex) {
                                      // Adjust default index if a previous item is removed
                                      models[form.name][input.label + '_defaults'][optionKey] = models[form.name][input.label + '_defaults'][optionKey] - 1;
                                    }
                                    nestedArray.splice(itemIndex, 1);
                                    if (nestedArray.length === 0) {
                                      // Set to null so update action can handle deletion generically
                                      $set(models[form.name][input.label], optionKey, null);
                                      if (models[form.name][input.label + '_defaults']) {
                                        $delete(models[form.name][input.label + '_defaults'], optionKey);
                                      }
                                    } else {
                                      $set(models[form.name][input.label], optionKey, nestedArray);
                                    }
                                  "
                                >
                                  <i class="fa fa-trash r4"></i> Remove
                                </button>
                              </div>

                              <!-- Dynamic inputs based on nestedModel -->
                              <div
                                v-for="(propDefault, propKey) in input.nestedModel"
                                :key="propKey"
                                class="flex column b4"
                              >
                                <label class="xs-font r4">{{ propKey }}</label>
                                <input
                                  v-if="typeof propDefault === 'number'"
                                  type="number"
                                  class="xs-font xs-input"
                                  :value="item && typeof item === 'object' ? item[propKey] : ''"
                                  @input="
                                    if (!item || typeof item !== 'object') {
                                      const newItem = {};
                                      Object.keys(input.nestedModel || {}).forEach(p => {
                                        newItem[p] = input.nestedModel[p];
                                      });
                                      const arr = models[form.name][input.label][selectedOption];
                                      arr[itemIndex] = newItem;
                                      $set(models[form.name][input.label], selectedOption, arr);
                                    }
                                    $set(item, propKey, $event.target.value ? parseFloat($event.target.value) : 0);
                                  "
                                  :placeholder="propKey"
                                />
                                <textarea
                                  v-else-if="typeof propDefault === 'string' && propDefault.length > 50"
                                  class="xs-font xs-input"
                                  :value="item && typeof item === 'object' ? item[propKey] : ''"
                                  @input="
                                    if (!item || typeof item !== 'object') {
                                      const newItem = {};
                                      Object.keys(input.nestedModel || {}).forEach(p => {
                                        newItem[p] = input.nestedModel[p];
                                      });
                                      const arr = models[form.name][input.label][selectedOption];
                                      arr[itemIndex] = newItem;
                                      $set(models[form.name][input.label], selectedOption, arr);
                                    }
                                    $set(item, propKey, $event.target.value);
                                  "
                                  :placeholder="propKey"
                                  rows="3"
                                />
                                <input
                                  v-else
                                  type="text"
                                  class="xs-font xs-input"
                                  :value="item && typeof item === 'object' ? item[propKey] : ''"
                                  @input="
                                    if (!item || typeof item !== 'object') {
                                      const newItem = {};
                                      Object.keys(input.nestedModel || {}).forEach(p => {
                                        newItem[p] = input.nestedModel[p];
                                      });
                                      const arr = models[form.name][input.label][selectedOption];
                                      arr[itemIndex] = newItem;
                                      $set(models[form.name][input.label], selectedOption, arr);
                                    }
                                    $set(item, propKey, $event.target.value);
                                  "
                                  :placeholder="propKey"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- FILE -->
                        <div
                          style="position: relative"
                          v-if="input.inputType === 'file'"
                        >
                          <div class="xs-font flex column">
                            <div class="flex column xs-font fit">
                              <media
                                @change="
                                  input.method && input.methodtype
                                    ? $store[input.methodtype || 'dispatch'](
                                        input.method,
                                        {
                                          files: $event.target.files,
                                          name: input.label,
                                        }
                                      )
                                    : null
                                "
                                :name="input.label"
                                :m="input.method"
                                :mtype="input.methodtype"
                                view="compact"
                                select
                                v-model="models[form.name][input.label]"
                              ></media>
                              <label
                                class="xs-font"
                                :for="form.name + input.label"
                                >Image URL</label
                              >
                              <input
                                class="xs-font"
                                placeholder="File URL"
                                type="url"
                                :id="form.name.norm() + input.label.norm()"
                                :class="form.name.norm() + input.label.norm()"
                                v-model="models[form.name][input.label]"
                              />
                              <img
                                style="max-width: 270px"
                                v-if="models[form.name][input.label]"
                                :src="models[form.name][input.label]"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- CHECK -->
                        <div
                          class="flexz p4 align-center"
                          v-if="input.inputType == 'check'"
                        >
                          <div
                            class="flex align-center wrap"
                            @click="
                              $set(
                                models[form.name],
                                input.label,
                                !models[form.name][input.label]
                              ),
                                input.required
                                  ? (required[form.name][input.label] = true)
                                  : null
                            "
                          >
                            <i
                              :class="
                                !models[form.name][input.label]
                                  ? 'fa fa-lg fa-square r8'
                                  : 'fa fa-lg fa-check-square r8 update-text'
                              "
                            ></i>
                            <icontent
                              class="xs-font flex align-center"
                              :content="input.placeholder"
                            />
                          </div>
                        </div>

                        <!-- DATE -->
                        <div
                          class="sub-container flex around xs-font column"
                          v-if="input.inputType == 'date-time'"
                        >
                          <label
                            class="flex wrap"
                            :for="form.name + '-' + input.label"
                          >
                            <input
                              :disabled="input.disabled"
                              type="datetime-local"
                              class="p8 m4"
                              :id="form.name.norm() + '-' + input.label.norm()"
                              :class="
                                form.name.norm() + '-' + input.label.norm()
                              "
                              @change="
                                $set(
                                  models[form.name],
                                  input.label,
                                  Math.floor(
                                    new Date(
                                      show['date' + form.name + input.label]
                                    ).valueOf()
                                  )
                                )
                              "
                              v-model="show['date' + form.name + input.label]"
                            />
                            <!-- <i class="xs-font">{{Intl.DateTimeFormat().resolvedOptions().timeZone}}</i> -->
                          </label>
                        </div>

                        <!-- PAGE -->
                        <pageadmin
                          :pagekey="inputKey"
                          v-if="form.name === 'pages'"
                          :input="input"
                          @value="models.pages[input.label]"
                          :page="input.label"
                          :form="form"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- USERS -->

                <div
                  class="xs-font p8 flexy container"
                  v-if="form.name === 'users'"
                >
                  <div
                    v-for="(user, userid) in $store.state.userlist"
                    :key="userid + $store.state.counter"
                    class="b16"
                  >
                    <div
                      v-if="
                        !formsearch ||
                        JSON.stringify(user)
                          .toLowerCase()
                          .includes(formsearch.toLowerCase())
                      "
                    >
                      <div
                        style="border-bottom: 2px solid black"
                        class="flex between wrap"
                      >
                        <user :userid="user.id" />
                        <i
                          @click="$set(show.user, user.id, !show.user[user.id])"
                          class="r4 l4"
                          >{{ user.id }}</i
                        >
                        <a target="_blank" :href="`mailto:${user.email}`">
                          {{ user.email }}
                        </a>
                      </div>
                      <div class="flex between align-center wrap b8 t8">
                        <b>Roles:</b>
                        <span
                          :class="
                            $store.state.app.advanced.roles[rolekey].members &&
                            $store.state.app.advanced.roles[
                              rolekey
                            ].members.indexOf(user.id) > -1
                              ? 'update-text'
                              : ''
                          "
                          @click="
                            !$store.state.app.advanced.roles[rolekey].members
                              ? ($store.state.app.advanced.roles[
                                  rolekey
                                ].members = [])
                              : null;
                            $store.state.app.advanced.roles[
                              rolekey
                            ].members.indexOf(user.id) === -1
                              ? $store.state.app.advanced.roles[
                                  rolekey
                                ].members.push(user.id)
                              : $store.state.app.advanced.roles[
                                  rolekey
                                ].members.splice(
                                  $store.state.app.advanced.roles[
                                    rolekey
                                  ].members.indexOf(user.id),
                                  1
                                );
                            $set(
                              models.users.roles[rolekey],
                              'members',
                              $store.state.app.advanced.roles[rolekey].members
                            );
                            $set(
                              $store.state,
                              'counter',
                              $store.state.counter + 1
                            );
                          "
                          v-for="(role, rolekey) in models.users.roles"
                          :key="rolekey + 'available'"
                        >
                          <i
                            v-if="
                              $store.state.app.advanced.roles[rolekey]
                                .members &&
                              $store.state.app.advanced.roles[
                                rolekey
                              ].members.indexOf(user.id) > -1
                            "
                            class="fa fa-check"
                          ></i>
                          {{ rolekey }}
                        </span>
                      </div>
                      <div v-if="user.required">
                        <b>Required Data Submitted</b>
                        <div
                          v-for="(role, rolekey) in $store.state.app.advanced
                            .roles"
                          :key="rolekey"
                        >
                          <div
                            class="flex align-center wrap container p4"
                            v-if="Object.keys(role.requirements).length > 0"
                          >
                            <b>{{ rolekey }} >></b>
                            <span
                              class="flex align-center"
                              v-for="(req, reqkey) in role.requirements"
                              :key="reqkey"
                            >
                              {{ reqkey }} >>
                              <span
                                v-for="(
                                  validation, validationi
                                ) in req.validations"
                                :key="validationi"
                              >
                                {{ validation.value }} >>
                                <span
                                  class="m4"
                                  v-for="(entry, entryi) in validation.options"
                                  :key="entryi"
                                >
                                  <span
                                    :class="
                                      user.required &&
                                      user.required[reqkey] &&
                                      user.required[reqkey][validation.value] &&
                                      user.required[reqkey][
                                        validation.value
                                      ].indexOf(entry) > -1
                                        ? 'update-text'
                                        : ''
                                    "
                                    >{{ entry }}</span
                                  >
                                  <!-- <span v-if="user.required && user.required[reqkey]">{{user.required[reqkey][validation.value]}}</span> -->
                                </span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex between wrap">
                        <span
                          v-if="user.orders"
                          @click="
                            $set(
                              show.user,
                              user.id + 'orders',
                              !show.user[user.id + 'orders']
                            )
                          "
                        >
                          <b>Orders:</b>
                          {{ user.orders.length }}
                        </span>
                        <span
                          v-if="user.sales"
                          @click="
                            $set(
                              show.user,
                              user.id + 'sales',
                              !show.user[user.id + 'sales']
                            )
                          "
                        >
                          <b>Sales:</b>
                          {{ Object.entries(user.sales).length }}
                        </span>
                        <!-- <span v-if="user.items"
                          @click="
                            $set(
                              show.user,
                              user.id + 'items',
                              !show.user[user.id + 'items']
                            )
                          "
                          ><b>Items: </b
                          >{{
                            Object.entries(user.items).reduce(
                              (a, b) => a[1].length + b[1].length
                            )
                        }}</span>-->
                      </div>
                      <state
                        tree="true"
                        :statedata="user"
                        v-if="show.user[user.id]"
                      />
                      <div v-if="show.user[user.id + 'orders']" class="p4">
                        <b>Orders:</b>
                        <router-link
                          class="r4"
                          :to="`/order/${order}`"
                          v-for="(order, i) in user.orders"
                          :key="i"
                          >{{ order }}</router-link
                        >
                      </div>
                      <div v-if="show.user[user.id + 'sales']" class="p4">
                        <b>Sales:</b>
                        <router-link
                          class="r4 flex between wrap"
                          :to="`/sales/${i}`"
                          v-for="(sale, i) in user.sales"
                          :key="i"
                        >
                          <itime :timestamp="sale[0].timestamp" />
                          {{ sale[0].status }}
                          <b>{{ i }}</b>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <comments
              class="p8"
              v-if="thisform.name == 'Update App'"
              :depth="1"
              :commentsid="
                'update.' + $store.state.app.basics.database + '.' + form.name
              "
            />
          </div>
        </div>
      </template>
      <template #footer>
        <div
          class="
            container
            flex
            between
            align-center
            flexy
            xs-font
            form_footer
            p4
          "
        >
          <a
            v-if="thisform.forms.length > 1"
            @click.prevent="
              wizardStage > 1 &&
                ((wizardStage = wizardStage - 1),
                scrollUp((thisform.name + wizardStage).norm()))
            "
            :style="`opacity: ${wizardStage > 1 ? '1' : '.1'}`"
            class="xs-font r16 flex between align-center"
            type="button"
          >
            <i class="fas fa-chevron-left fa-3x l8"></i>
          </a>
          <button
            :disabled="
              !required || JSON.stringify(required).indexOf('false') > -1
            "
            type="submit"
            :class="
              (thisform.forms.length === 1 ? ' flexy ' : ' ') +
              (thisform.submit.method || ' update ')
            "
            class="flex column p8 xs-font"
          >
            {{
              submittext
                ? submittext
                : thisform.name === "Checkout"
                ? "PURCHASE"
                : prefill
                ? "UPDATE"
                : thisform.submit.method.toUpperCase()
            }}
          </button>
          <i
            v-if="$store.state.show.reinit"
            @click="$store.dispatch('init')"
            class="fa fa-retweet l8 indicate-text lg-font"
          ></i>
          <a
            v-if="thisform.forms.length > 1"
            @click.prevent="
              wizardStage < thisform.forms.length &&
                ((wizardStage = wizardStage + 1),
                scrollUp((thisform.name + wizardStage).norm()))
            "
            :style="`opacity: ${
              wizardStage < thisform.forms.length ? '1' : '.1'
            }`"
            class="xs-font l16"
            type="button"
          >
            <i class="fas fa-chevron-right fa-3x r8"></i>
          </a>
        </div>
      </template>
    </layout>
  </form>
</template>
<script>
import Vue2Filters from "vue2-filters";

export default {
  data() {
    return {
      addPageTitle: "",
      basicGroup: {
        name: "basics",
        description: "The basic bits of an item.",
        inputs: [
          {
            display: { list: true, single: true, form: true },
            inputType: "input",
            label: "title",
            type: "text",
            placeholder: "title",
            default: "",
            priority: 1,
          },
          {
            display: { list: true, single: true, form: true },
            inputType: "textarea",
            label: "description",
            type: "text",
            placeholder: "Description",
            default: "",
            priority: 2,
          },
          {
            display: { list: true, single: true, form: true },
            inputType: "file",
            label: "image",
            type: "image",
            placeholder: "Image Url",
            default: "",
            priority: 3,
          },
          {
            display: { list: true, single: true, form: true },
            inputType: "tags",
            label: "tags",
            type: "tags",
            placeholder: "tags",
            default: [],
            priority: 4,
          },
          {
            display: { list: true, single: true, form: true },
            inputType: "check",
            label: "published",
            type: "text",
            placeholder: "Publish this item",
            default: true,
            priority: 4,
          },
          {
            display: { list: false, single: true, form: true },
            inputType: "check",
            label: "bypassTruncation",
            type: "text",
            placeholder: "Bypass text truncation",
            default: false,
            priority: 5,
          },
        ],
      },
      chooseAbility: {},
      chooseIcon: {},
      edited: "",
      formsearch: "",
      models: {},
      newCondition: {},
      newTag: "",
      newInput: {},
      newItem: "",
      newMenu: "",
      newForm: {},
      newType: "asset",
      required: {},
      restrictedTypes: [
        ...this.$store.state.modules,
        ...this.$store.state.abilityTypes,
      ],
      search: {},
      searchIcon: "",
      selectedRecipe: "", // Cheat to highlight new selection
      show: (() => {
        return {
          addapi: false,
          activateMods: false,
          addPage: false,
          form: false,
          inputs: {},
          label: {},
          itemConfig: {},
          modsAndItems: false,
          recipes: false,
          contentType: "",
          remove: {},
          user: {},
          dataBrowse: {},
        };
      })(),
      values: [],
      wizardStage: 1,
    };
  },
  async mounted() {
    if (this.thisform.name === "New App") {
      ["basics", "advanced", "style", "pages", "users"].map((x) => {
        !this.models[x] ? (this.models[x] = {}) : null;
        !this.$store.state.app[x] ? (this.$store.state.app[x] = {}) : null;
      });
      this.$set(this.models.basics, "database", location.hostname);
    }
    (await this.show)
      ? this.setModel()
      : setTimeout(() => this.setModel(), 1000);
  },
  methods: {
    conditionscheck(conditions, model) {
      if (!conditions || !Array.isArray(conditions)) {
        return false;
      }
      
      // Handle simple array format: ["payment-type", "Credit"]
      if (conditions.length === 2 && typeof conditions[0] === 'string' && typeof conditions[1] === 'string') {
        const [key, value] = conditions;
        const result = model[key] === value;
        console.log(`PAYMENT FORM: ${key} === ${value} = ${result} (current: ${model[key]})`);
        return result;
      }
      
      // Handle object format for complex conditions
      return conditions.every((x) => {
        if (x.conditions && x.conditions.length > 0) {
          // For now, skip advanced conditions in sync context
          return true;
        }
        if (x.value == true) {
          return (
            model[x.key] && model[x.key][x.prop] && ("" + model[x.key][x.prop]).length > 0
          );
        } else if (x.value == false)
          return (
            !model[x.key] || !model[x.key][x.prop] || ("" + model[x.key][x.prop]).length == 0
          );
        else return model[x.key] && model[x.key][x.prop] == x.value;
      });
    },
    onEdit(evt) {
      var src = evt.target.innerText;
      return (this.edited = src);
    },
    setModel(val) {
      var properModel =
        this.thisform.forms || this.thisform[this.$route.params.type];
      var retModel = {};
      if (this.prefill) {
        properModel.forEach((form) => {
          this.prefill[form.name] = this.prefill[form.name] || {};
          form.inputs.forEach((input) => {
            this.prefill[form.name][input.label] =
              this.prefill[form.name][input.label] || input.default || "";
            // Initialize defaults and priorities for select-nested inputs
            if (input.inputType === "select-nested") {
              this.prefill[form.name][input.label + '_defaults'] =
                this.prefill[form.name][input.label + '_defaults'] || {};
              this.prefill[form.name][input.label + '_priorities'] =
                this.prefill[form.name][input.label + '_priorities'] || {};
            }
          });
        });
        retModel = this.prefill;
      } else {
        properModel.forEach((form) => {
          retModel[form.name] = {};
          form.inputs.forEach((input) => {
            if (input.required) {
              if (!this.required) this.required = {};
              this.required[form.name] = this.required[form.name] || {};
              this.required[form.name][input.label] = false;
            }
            if (input.inputType === "tags") {
              retModel[form.name][input.label] = [];
            } else if (input.inputType === "select-nested") {
              let variationsData = val && val[form.name] && val[form.name][input.label]
                ? val[form.name][input.label]
                : this.$store.state.models.retModel &&
                  this.$store.state.models.retModel[form.name] &&
                  this.$store.state.models.retModel[form.name][input.label]
                ? this.$store.state.models.retModel[form.name][input.label]
                : input.default && typeof input.default === 'object'
                ? input.default
                : {};
              
              // Ensure variations is an object and each value is an array
              if (variationsData && typeof variationsData === 'object') {
                const cleanedVariations = {};
                Object.keys(variationsData).forEach(key => {
                  const value = variationsData[key];
                  if (Array.isArray(value)) {
                    // Ensure each item in array is an object
                    cleanedVariations[key] = value.map(item => {
                      if (typeof item === 'object' && item !== null) {
                        return item;
                      } else {
                        // Convert string/primitive to object with default structure
                        const newItem = {};
                        Object.keys(input.nestedModel || {}).forEach(prop => {
                          newItem[prop] = typeof input.nestedModel[prop] === 'object' && input.nestedModel[prop] !== null
                            ? JSON.parse(JSON.stringify(input.nestedModel[prop]))
                            : input.nestedModel[prop] !== undefined
                            ? input.nestedModel[prop]
                            : '';
                        });
                        return newItem;
                      }
                    });
                  } else if (typeof value === 'string' || typeof value === 'number') {
                    // Skip invalid data - don't convert strings/numbers to arrays
                    console.warn('Invalid variation data for', key, ':', value);
                  } else {
                    cleanedVariations[key] = [];
                  }
                });
                retModel[form.name][input.label] = cleanedVariations;
              } else {
                retModel[form.name][input.label] = {};
              }
              
              // Initialize defaults object
              retModel[form.name][input.label + '_defaults'] =
                val && val[form.name] && val[form.name][input.label + '_defaults']
                  ? val[form.name][input.label + '_defaults']
                  : this.$store.state.models.retModel &&
                    this.$store.state.models.retModel[form.name] &&
                    this.$store.state.models.retModel[form.name][input.label + '_defaults']
                  ? this.$store.state.models.retModel[form.name][input.label + '_defaults']
                  : {};
              // Initialize priorities object
              retModel[form.name][input.label + '_priorities'] =
                val && val[form.name] && val[form.name][input.label + '_priorities']
                  ? val[form.name][input.label + '_priorities']
                  : this.$store.state.models.retModel &&
                    this.$store.state.models.retModel[form.name] &&
                    this.$store.state.models.retModel[form.name][input.label + '_priorities']
                  ? this.$store.state.models.retModel[form.name][input.label + '_priorities']
                  : {};
            } else {
              retModel[form.name][input.label] =
                val && val[form.name]
                  ? val[form.name][input.label]
                  : this.$store.state.models.retModel &&
                    this.$store.state.models.retModel[form.name]
                  ? this.$store.state.models.retModel[form.name][input.label]
                  : input.default || "";
            }
          });
        });
      }
      this.$set(this.$store.state.models.retModel, this.thisform.name, {
        model: retModel,
        source: JSON.stringify(retModel),
      });
      this.models = retModel || this.models;
      this.show = this.show || {};
      this.$set(this.show, "form", true);
      this.checkReqs(properModel);
    },
    checkReqs(properModel) {
      let forms = properModel || this.thisform.forms;
      forms.forEach((form) => {
        form.inputs.forEach((input) => {
          if (
            input.type === "date-time" &&
            this.models[form.name][input.label]
          ) {
            this.$set(
              this.show,
              "date" + form.name + input.label,
              new Date(this.models[form.name][input.label])
                .toISOString()
                .slice(0, -8)
            );
          }
          if (input.required === true) {
            this.required = this.required || {};
            this.$set(this.required, form.name, this.required[form.name] || {});
            this.$set(this.required[form.name], input.label, false);
          }
          if (input.if && input.required) {
            if (
              this.models[form.name][input.if[0]] === input.if[1] &&
              !this.models[form.name][input.label]
            ) {
              this.required[form.name] = this.required[form.name] || {};
              this.required[form.name][input.label] = false;
            } else if (
              this.models[form.name][input.if[0]] === input.if[1] &&
              this.models[form.name][input.label]
            ) {
              this.required[form.name] = this.required[form.name] || {};
              this.required[form.name][input.label] = true;
            } else {
              delete this.required[form.name][input.label];
            }
          }
        });
      });
    },
    prepUpload(files, formName, inputName, sub, hash) {
      return this.$store.dispatch("upload", { files, hash }).then((ret) => {
        return ret.ref.getDownloadURL().then((dlLink) => {
          sub
            ? (this.models[formName][inputName][sub[0]][sub[1]][sub[2]].image =
                dlLink)
            : (this.models[formName][inputName] = dlLink);
          return this.models;
        });
      });
    },
    removeAbility(ability, forms) {
      forms.forEach((form, formKey) => {
        if (form.name === ability) {
          forms.splice(formKey, 1);
        }
      });
      return forms;
    },
    scrollUp(id) {
      this.$nextTick(() => {
        var element = document.getElementById(id || "main");
        return element.scrollIntoView();
      });
    },
    submitMethod(method, payload) {
      console.log("submitting", payload);
      const ts = Date.now();
      if (this.prefill) {
        method = "update";
      }
      if (payload.data.basics) {
        payload.data.basics.title = payload.data.basics.title || ts;
        // Extract password from basics if it exists (for email updates)
        if (payload.data.basics.password) {
          payload.password = payload.data.basics.password;
          // Don't save password to Firestore
          delete payload.data.basics.password;
        }
      } else {
        payload.data.title = payload.data.title || ts;
      }
      if (payload.id || payload.data.id)
        payload.id = payload.id || payload.data.id;
      this.$store.dispatch(method, payload).then((d) => {
        this.$set(this, "models", d);
        this.setModel();
      }).catch((error) => {
        console.error("Form submission error:", error);
        alert(error.message || "An error occurred. Please try again.");
      });
    },
  },
  computed: {
    thisform() {
      return (
        this.formModel || this.$store.state.app.forms[this.title] || "Error"
      );
    },
  },
  mixins: [Vue2Filters.mixin],
  name: "iform",
  props: {
    "form-model": { type: Object },
    prefill: { type: Object },
    submittext: { type: String },
    searchenabled: { type: String },
    title: { type: [String, Boolean] },
    relative: { type: [String, Boolean] },
    section: { type: [String, Number] },
  },
  watch: {
    models: {
      handler: function (newVal, oldVal) {
        // this.checkReqs(this.model);
        if (JSON.stringify(oldVal) === JSON.stringify(newVal)) {
          return;
        } else {
          return this.setModel(newVal);
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.newitem-img {
  background-size: cover;
  width: 100%;
  min-width: 240px;
  height: auto;
  object-fit: cover;
}
</style>